<template>
  <div class="swimlane-editor">
    <div class="editor-content">
      <!-- 左侧元素库 -->
      <div class="element-library">
        <div class="panel-header">
          <div class="panel-title">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="panel-icon">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h4a1 1 0 011 1v7a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM14 5a1 1 0 011-1h4a1 1 0 011 1v7a1 1 0 01-1 1h-4a1 1 0 01-1-1V5zM4 16a1 1 0 011-1h4a1 1 0 011 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-3zM14 16a1 1 0 011-1h4a1 1 0 011 1v3a1 1 0 01-1 1h-4a1 1 0 01-1-1v-3z"/>
            </svg>
            <span>泳道图</span>
          </div>
          <button class="btn-history" @click="showHistoryDialog">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            历史泳道图
          </button>
        </div>
        <div class="save-reminder">
          💡 提示：AI生成成功后会自动保存泳道图。
        </div>


        <div class="ai-form-panel">
          <el-form :model="aiForm" label-position="top">
            <el-form-item label="课题名称">
              <el-input v-model="aiForm.projectName" placeholder="例如：在线购物系统" clearable />
            </el-form-item>
            <el-form-item label="业务流程名称">
              <el-input v-model="aiForm.moduleName" placeholder="例如：用户下单流程" clearable />
            </el-form-item>
            <el-form-item label="角色">
              <div class="actor-tags">
                <el-tag
                  v-for="(actor, index) in aiForm.actorList"
                  :key="index"
                  size="medium"
                  closable
                  @close="removeActor(index)"
                  style="margin: 0 4px 4px 0; font-size: 14px;"
                >{{ actor }}</el-tag>
                <div v-if="actorInputVisible" style="display:inline-block;">
                  <el-input
                    ref="actorInput"
                    v-model="actorInputValue"
                    size="small"
                    style="width: 100px;"
                    placeholder="输入角色名"
                    @keyup.enter.native="confirmActor"
                    @blur="confirmActor"
                  />
                </div>
                <el-button v-else type="primary" size="small" @click="showActorInput">+ 新增角色</el-button>
              </div>
              <div class="save-reminder" style="margin: 6px 0 0 0;padding: 1px 15px;">💡 有几个角色参与，就新增几个角色。</div>
            </el-form-item>
            <el-form-item label="系统业务描述">
              <textarea
                v-model="aiForm.functionDescription"
                class="func-editor"
                placeholder="请描述某一功能模块中各角色的业务流程，例如：
用户下单流程：
- 用户：浏览商品、选择商品、提交订单、完成支付、确认收货
- 商家：确认订单、备货发货、处理售后
- 管理员：监控订单状态、处理异常订单、查看统计数据"
              />
            </el-form-item>
          </el-form>
        </div>

        <div class="panel-footer">
          <button class="btn-ai btn-generate" @click="submitAIGenerate">
            <span class="btn-content">
              <img src="@/assets/ai-logo.png" alt="AI" class="ai-icon" />
              AI泳道图
            </span>
            <span class="btn-points">（消耗{{ pointsConfig.swimlaneDiagram }}积分）</span>
          </button>
        </div>
      </div>

      <!-- 右侧画布区域 -->
      <div class="canvas-area">
        <div class="tabs-container">
          <div class="tabs">
            <button class="tab active">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h4a1 1 0 011 1v7a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM14 5a1 1 0 011-1h4a1 1 0 011 1v7a1 1 0 01-1 1h-4a1 1 0 01-1-1V5zM4 16a1 1 0 011-1h4a1 1 0 011 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-3zM14 16a1 1 0 011-1h4a1 1 0 011 1v3a1 1 0 01-1 1h-4a1 1 0 01-1-1v-3z"/>
              </svg>
              泳道图画布
            </button>
          </div>
          <div class="canvas-actions">
            <button class="tool-btn btn-green" @click="zoomIn" title="放大">
              <i class="el-icon-zoom-in"></i>放大
            </button>
            <button class="tool-btn btn-teal" @click="zoomOut" title="缩小">
              <i class="el-icon-zoom-out"></i>缩小
            </button>
            <button class="tool-btn btn-orange" @click="clearCanvas" title="清空画布">
              <i class="el-icon-delete"></i>清空画布
            </button>
            <button class="tool-btn btn-blue" @click="openExportDialog" title="导出泳道图">
              <i class="el-icon-download"></i>导出泳道图
            </button>
            <button class="tool-btn btn-purple" @click="toggleFullscreen" :title="isFullscreen ? '退出全屏' : '全屏查看'">
              <i class="el-icon-full-screen"></i>{{ isFullscreen ? '退出全屏' : '全屏' }}
            </button>
          </div>
        </div>

        <div class="toolbar">
          <!-- 提醒区域 -->
          <div class="tip-banner">
            💡 提示：可导出为 Draw.io 文件进行进一步编辑和美化，支持全屏模式获得更大编辑空间。
          </div>
        </div>

          <!-- 参数设置 -->
          <div class="params-setting">
              <div class="param-item">
                <label>字体:</label>
                <el-select v-model="fontFamily" size="small" style="width: 100px;" @change="updateFont">
                  <el-option label="宋体" value="SimSun"></el-option>
                  <el-option label="微软雅黑" value="Microsoft YaHei"></el-option>
                  <el-option label="黑体" value="SimHei"></el-option>
                  <el-option label="仿宋" value="FangSong"></el-option>
                  <el-option label="楷体" value="KaiTi"></el-option>
                  <el-option label="Arial" value="Arial"></el-option>
                </el-select>
              </div>

              <div class="param-item">
                <label>字体大小:</label>
                <el-select v-model="fontSize" size="small" style="width: 80px;" @change="updateFont">
                  <el-option label="10px" :value="10"></el-option>
                  <el-option label="12px" :value="12"></el-option>
                  <el-option label="14px" :value="14"></el-option>
                  <el-option label="16px" :value="16"></el-option>
                  <el-option label="18px" :value="18"></el-option>
                  <el-option label="20px" :value="20"></el-option>
                  <el-option label="22px" :value="22"></el-option>
                </el-select>
              </div>

              <div class="param-item">
                <label>字体加粗:</label>
                <el-select v-model="fontWeight" size="small" style="width: 80px;" @change="updateFont">
                  <el-option label="正常" value="normal"></el-option>
                  <el-option label="加粗" value="bold"></el-option>
                </el-select>
              </div>



              <div class="param-item">
                <label>线条宽度:</label>
                <div class="number-input">
                  <el-button size="small" @click="decreaseLineWidth">-</el-button>
                  <span class="number-value">{{ lineWidth }}</span>
                  <el-button size="small" @click="increaseLineWidth">+</el-button>
                </div>
              </div>

              <div class="param-item">
                <label>箭头尺寸:</label>
                <el-select v-model="arrowSize" size="small" style="width: 80px;" @change="updateArrowSize">
                  <el-option label="无" value="none"></el-option>
                  <el-option label="小" value="small"></el-option>
                  <el-option label="中" value="medium"></el-option>
                  <el-option label="大" value="large"></el-option>
                </el-select>
              </div>
          </div>
          <div class="canvas-content">
            <div
              class="canvas"
              @click="onCanvasClick"
            >
          <svg
            ref="diagramSvg"
            width="100%"
            height="100%"
            class="diagram-svg"
            :viewBox="computedViewBox"
            @mousedown="onCanvasMouseDown"
            @mousemove="onCanvasMouseMove"
            @mouseup="onCanvasMouseUp"
            @mouseleave="onCanvasMouseUp"
            :class="{ 'panning': isPanning }"
          >
            <!-- 定义箭头标记 -->
            <defs>
              <marker id="arrowhead" :markerWidth="arrowDimensions.width" :markerHeight="arrowDimensions.height"
                      :refX="arrowDimensions.refX" :refY="arrowDimensions.refY" orient="auto">
                <polygon :points="arrowDimensions.points" :fill="lineColor" />
              </marker>
              <!-- 空心箭头标记（泛化关系） -->
              <marker id="hollow-arrowhead" :markerWidth="hollowArrowDimensions.width" :markerHeight="hollowArrowDimensions.height"
                      :refX="hollowArrowDimensions.refX" :refY="hollowArrowDimensions.refY" orient="auto">
                <polygon :points="hollowArrowDimensions.points" fill="white" :stroke="lineColor" :stroke-width="lineWidth" />
              </marker>
            </defs>

            <!-- 渲染系统边界 -->
            <g class="boundaries-layer">
              <g
                v-for="boundary in boundaries"
                :key="boundary.id"
                class="boundary"
                :class="{ selected: selectedElement && selectedElement.id === boundary.id }"
                @mousedown.stop="onElementMouseDown(boundary, $event)"
              >
                <!-- 可拖拽区域（透明矩形） -->
                <rect
                  :x="boundary.x - boundary.width/2"
                  :y="boundary.y - boundary.height/2"
                  :width="boundary.width"
                  :height="boundary.height"
                  fill="transparent"
                  class="drag-area"
                />
                <!-- 选中框 -->
                <rect
                  v-if="selectedElement && selectedElement.id === boundary.id"
                  :x="boundary.x - boundary.width/2 - 5"
                  :y="boundary.y - boundary.height/2 - 5"
                  :width="boundary.width + 10"
                  :height="boundary.height + 10"
                  fill="none" stroke="#1890ff" stroke-width="2"
                  stroke-dasharray="5,5"
                />
                <!-- 边界矩形 -->
                <rect
                  v-if="!boundary.isEllipse && !boundary.isDiamond"
                  :x="boundary.x - boundary.width/2"
                  :y="boundary.y - boundary.height/2"
                  :width="boundary.width"
                  :height="boundary.height"
                  :fill="boundary.isLane || boundary.isPool ? 'none' : 'white'" :stroke="lineColor" :stroke-width="lineWidth"
                  :stroke-dasharray="boundary.isDashed ? '8,4' : 'none'"
                />
                <!-- Pool 左侧标题栏（竖向分隔线 + 竖排文字） -->
                <g v-if="boundary.isPool">
                  <!-- 标题栏背景 -->
                  <rect
                    :x="boundary.x - boundary.width/2"
                    :y="boundary.y - boundary.height/2"
                    :width="boundary.poolTitleW || 30"
                    :height="boundary.height"
                    fill="none" :stroke="lineColor" :stroke-width="lineWidth"
                  />
                  <!-- 竖排标题文字 -->
                  <text
                    :x="boundary.x - boundary.width/2 + (boundary.poolTitleW || 30)/2"
                    :y="boundary.y"
                    text-anchor="middle"
                    dominant-baseline="middle"
                    :style="dynamicFontStyle"
                    :transform="`rotate(-90, ${boundary.x - boundary.width/2 + (boundary.poolTitleW||30)/2}, ${boundary.y})`"
                    @click.stop="startEdit(boundary)"
                  >{{ boundary.name }}</text>
                </g>
                <!-- 泳道顶部标题横线 -->
                <line
                  v-if="boundary.isLane"
                  :x1="boundary.x - boundary.width/2"
                  :y1="boundary.y - boundary.height/2 + 30"
                  :x2="boundary.x + boundary.width/2"
                  :y2="boundary.y - boundary.height/2 + 30"
                  :stroke="lineColor" :stroke-width="lineWidth"
                />
                <!-- 椭圆（开始/结束节点） -->
                <ellipse
                  v-if="boundary.isEllipse"
                  :cx="boundary.x"
                  :cy="boundary.y"
                  :rx="boundary.width/2"
                  :ry="boundary.height/2"
                  fill="white" :stroke="lineColor" :stroke-width="lineWidth"
                />
                <!-- 菱形（判断节点） -->
                <polygon
                  v-if="boundary.isDiamond"
                  :points="`${boundary.x},${boundary.y - boundary.height/2} ${boundary.x + boundary.width/2},${boundary.y} ${boundary.x},${boundary.y + boundary.height/2} ${boundary.x - boundary.width/2},${boundary.y}`"
                  fill="white" :stroke="lineColor" :stroke-width="lineWidth"
                />
                <!-- 节点/泳道文字（居中，无拖拽） -->
                <text
                  v-if="!(editingElement && editingElement.id === boundary.id) && !boundary.isPool"
                  :x="boundary.x"
                  :y="boundary.isLane ? boundary.y - boundary.height/2 + 15 : boundary.y + 4"
                  text-anchor="middle"
                  dominant-baseline="middle"
                  class="boundary-label"
                  :style="dynamicFontStyle"
                  @click.stop="startEdit(boundary)"
                >{{ boundary.name }}</text>
                <!-- 编辑状态的输入框 -->
                <foreignObject
                  v-if="editingElement && editingElement.id === boundary.id"
                  :x="boundary.x - 80" :y="boundary.y - 15" width="160" height="30"
                >
                  <input
                    :ref="'editInput_' + boundary.id"
                    v-model="editingText"
                    @keydown.enter="saveEdit"
                    @keydown.esc="cancelEdit"
                    @mousedown.stop
                    @click.stop
                    class="inline-edit-input"
                    type="text"
                  />
                </foreignObject>
                <!-- 删除按钮 -->
                <circle
                  v-if="selectedElement && selectedElement.id === boundary.id"
                  :cx="boundary.x + boundary.width/2 + 10"
                  :cy="boundary.y - boundary.height/2 - 10"
                  r="8" fill="#ff4d4f" stroke="white" stroke-width="2"
                  class="delete-btn"
                  @click.stop="deleteElement(boundary)"
                />
                <text
                  v-if="selectedElement && selectedElement.id === boundary.id"
                  :x="boundary.x + boundary.width/2 + 10"
                  :y="boundary.y - boundary.height/2 - 6"
                  text-anchor="middle" fill="white" font-size="12"
                  class="delete-btn"
                  @click.stop="deleteElement(boundary)"
                >×</text>
                <!-- 缩放控制点 -->
                <g v-if="selectedElement && selectedElement.id === boundary.id" class="resize-handles">
                  <!-- 右侧缩放点 (宽度) -->
                  <circle
                    :cx="boundary.x + boundary.width/2"
                    :cy="boundary.y"
                    r="4"
                    fill="#1890ff" stroke="white" stroke-width="2"
                    class="resize-handle resize-width"
                    @mousedown.stop="onResizeStart(boundary, $event, 'width')"
                  />
                  <!-- 下方缩放点 (高度) -->
                  <circle
                    :cx="boundary.x"
                    :cy="boundary.y + boundary.height/2"
                    r="4"
                    fill="#1890ff" stroke="white" stroke-width="2"
                    class="resize-handle resize-height"
                    @mousedown.stop="onResizeStart(boundary, $event, 'height')"
                  />
                  <!-- 右下角缩放点 (宽度和高度) -->
                  <circle
                    :cx="boundary.x + boundary.width/2"
                    :cy="boundary.y + boundary.height/2"
                    r="4"
                    fill="#52c41a" stroke="white" stroke-width="2"
                    class="resize-handle resize-both"
                    @mousedown.stop="onResizeStart(boundary, $event, 'both')"
                  />
                </g>
              </g>
            </g>

            <!-- 渲染关系线 -->
            <g class="relationships-layer">
              <g v-for="rel in relationships" :key="rel.id" class="relationship"
                 @mouseenter="setHoveredLine(rel)"
                 @mouseleave="clearHoveredLine()">
                <!-- 折线（有 waypoints） -->
                <path v-if="rel.waypoints && rel.waypoints.length"
                  :d="getPolylinePath(rel)"
                  :stroke="lineColor" :stroke-width="lineWidth"
                  :marker-end="getMarkerEnd(rel)"
                  :stroke-dasharray="rel.isDashed ? '5,5' : 'none'"
                  fill="none" class="line-main"
                  @click="selectLine(rel)"
                />
                <path v-if="rel.waypoints && rel.waypoints.length"
                  :d="getPolylinePath(rel)"
                  stroke="transparent" stroke-width="15" fill="none" class="line-drag-area"
                  @mousedown.stop="startLineDrag(rel, $event)"
                  @dblclick.stop="startEdit(rel)"
                />
                <!-- 直线（无 waypoints） -->
                <line v-if="!rel.waypoints || !rel.waypoints.length"
                  :x1="rel.x1" :y1="rel.y1"
                  :x2="rel.x2" :y2="rel.y2"
                  :stroke="lineColor"
                  :stroke-width="lineWidth"
                  :marker-end="getMarkerEnd(rel)"
                  :stroke-dasharray="rel.isDashed ? '5,5' : 'none'"
                  class="line-main"
                  @click="selectLine(rel)"
                />
                <!-- 直线可拖拽区域 -->
                <line v-if="!rel.waypoints || !rel.waypoints.length"
                  :x1="rel.x1" :y1="rel.y1"
                  :x2="rel.x2" :y2="rel.y2"
                  stroke="transparent"
                  stroke-width="15"
                  class="line-drag-area"
                  @mousedown.stop="startLineDrag(rel, $event)"
                  @dblclick.stop="startEdit(rel)"
                />
                <!-- 端点控制圆圈（选中或悬停时显示） -->
                <g v-if="(selectedElement && selectedElement.id === rel.id) || (hoveredLine && hoveredLine.id === rel.id)">
                  <circle
                    :cx="rel.x1" :cy="rel.y1"
                    r="5"
                    fill="#52c41a" stroke="white" stroke-width="2"
                    class="endpoint-handle start-point"
                    @mousedown.stop="startEndpointDrag(rel, 'start', $event)"
                  />
                  <circle
                    :cx="rel.x2" :cy="rel.y2"
                    r="5"
                    fill="#1890ff" stroke="white" stroke-width="2"
                    class="endpoint-handle end-point"
                    @mousedown.stop="startEndpointDrag(rel, 'end', $event)"
                  />
                </g>
                <!-- 文字标签 -->
                <text
                  v-if="!(editingElement && editingElement.id === rel.id) && rel.label && rel.label.trim()"
                  :x="getLabelX(rel)"
                  :y="getLabelY(rel)"
                  text-anchor="middle"
                  class="relationship-label"
                  :style="dynamicFontStyle"
                  @click.stop="startEdit(rel)"
                >
                  {{ rel.label }}
                </text>
                <!-- 编辑状态的输入框 -->
                <foreignObject
                  v-if="editingElement && editingElement.id === rel.id"
                  :x="(rel.x1 + rel.x2) / 2 - 50"
                  :y="(rel.y1 + rel.y2) / 2 - 20"
                  width="100" height="30"
                >
                  <input
                    :ref="'editInput_' + rel.id"
                    v-model="editingText"
                    @keydown.enter="saveEdit"
                    @keydown.esc="cancelEdit"
                    @mousedown.stop
                    @click.stop
                    class="inline-edit-input"
                    type="text"
                  />
                </foreignObject>
                <!-- 删除元素按钮（选中时显示） -->
                <circle
                  v-if="selectedElement && selectedElement.id === rel.id"
                  :cx="(rel.x1 + rel.x2) / 2 + 30"
                  :cy="(rel.y1 + rel.y2) / 2 - 20"
                  r="8" fill="#ff4d4f" stroke="white" stroke-width="2"
                  class="delete-btn"
                  @click.stop="deleteElement(rel)"
                />
                <text
                  v-if="selectedElement && selectedElement.id === rel.id"
                  :x="(rel.x1 + rel.x2) / 2 + 30"
                  :y="(rel.y1 + rel.y2) / 2 - 16"
                  text-anchor="middle" fill="white" font-size="12"
                  class="delete-btn"
                  @click.stop="deleteElement(rel)"
                >×</text>
                <!-- 删除文字按钮（选中且有文字时显示） -->
                <circle
                  v-if="selectedElement && selectedElement.id === rel.id && rel.label && rel.label.trim()"
                  :cx="(rel.x1 + rel.x2) / 2 - 30"
                  :cy="(rel.y1 + rel.y2) / 2 - 20"
                  r="8" fill="#faad14" stroke="white" stroke-width="2"
                  class="delete-text-btn"
                  @click.stop="deleteText(rel)"
                />
                <text
                  v-if="selectedElement && selectedElement.id === rel.id && rel.label && rel.label.trim()"
                  :x="(rel.x1 + rel.x2) / 2 - 30"
                  :y="(rel.y1 + rel.y2) / 2 - 16"
                  text-anchor="middle" fill="white" font-size="10"
                  class="delete-text-btn"
                  @click.stop="deleteText(rel)"
                >T×</text>
              </g>
            </g>

            <!-- 渲染参与者 -->
            <g class="actors-layer">
              <g
                v-for="actor in actors"
                :key="actor.id"
                class="actor"
                :class="{ selected: selectedElement && selectedElement.id === actor.id }"
                :transform="'translate(' + actor.x + ', ' + actor.y + ') scale(' + (actor.scale || 1) + ')'"
                @mousedown.stop="onElementMouseDown(actor, $event)"
              >
                <!-- 可拖拽区域（透明矩形） -->
                <rect
                  x="-30" y="-40" width="60" height="85"
                  fill="transparent"
                  class="drag-area"
                />
                <!-- 选中框 -->
                <rect
                  v-if="selectedElement && selectedElement.id === actor.id"
                  x="-25" y="-35" width="50" height="70"
                  fill="none" stroke="#1890ff" stroke-width="2"
                  stroke-dasharray="5,5"
                />
                <!-- 小人图标 -->
                <circle cx="0" cy="-20" r="8" fill="none" :stroke="lineColor" :stroke-width="lineWidth" vector-effect="non-scaling-stroke"/>
                <line x1="0" y1="-12" x2="0" y2="20" :stroke="lineColor" :stroke-width="lineWidth" vector-effect="non-scaling-stroke"/>
                <line x1="-15" y1="0" x2="15" y2="0" :stroke="lineColor" :stroke-width="lineWidth" vector-effect="non-scaling-stroke"/>
                <line x1="0" y1="20" x2="-10" y2="35" :stroke="lineColor" :stroke-width="lineWidth" vector-effect="non-scaling-stroke"/>
                <line x1="0" y1="20" x2="10" y2="35" :stroke="lineColor" :stroke-width="lineWidth" vector-effect="non-scaling-stroke"/>
                <!-- 显示文字或输入框 -->
                <g v-if="!(editingElement && editingElement.id === actor.id)">
                  <text
                    x="0" y="50"
                    text-anchor="middle"
                    class="actor-label"
                    :style="{
                      fontSize: (fontSize / (actor.scale || 1)) + 'px',
                      fontWeight: fontWeight,
                      fontFamily: fontFamily,
                      fill: fontColor
                    }"
                    @click.stop="startEdit(actor)"
                  >{{ actor.name }}</text>
                </g>
                <!-- 编辑状态的输入框 -->
                <foreignObject
                  v-if="editingElement && editingElement.id === actor.id"
                  x="-60" y="55" width="120" height="30"
                >
                  <input
                    :ref="'editInput_' + actor.id"
                    v-model="editingText"
                    @keydown.enter="saveEdit"
                    @keydown.esc="cancelEdit"
                    @mousedown.stop
                    @click.stop
                    class="inline-edit-input"
                    :style="{
                 fontSize: (fontSize / (actor.scale || 1)) + 'px',
                 fontFamily: fontFamily,
                 fontWeight: fontWeight
               }"
                    type="text"
                  />
                </foreignObject>
                <!-- 删除按钮 -->
                <circle
                  v-if="selectedElement && selectedElement.id === actor.id"
                  cx="20" cy="-30" r="8" fill="#ff4d4f" stroke="white" stroke-width="2"
                  class="delete-btn"
                  @click.stop="deleteElement(actor)"
                />
                <text
                  v-if="selectedElement && selectedElement.id === actor.id"
                  x="20" y="-26" text-anchor="middle" fill="white" font-size="12"
                  class="delete-btn"
                  @click.stop="deleteElement(actor)"
                >×</text>
                <!-- 缩放控制点 -->
                <g v-if="selectedElement && selectedElement.id === actor.id" class="resize-handles">
                  <!-- 右下角缩放点 -->
                  <circle
                    cx="25" cy="35" r="4"
                    fill="#1890ff" stroke="white" stroke-width="2"
                    class="resize-handle"
                    @mousedown.stop="onResizeStart(actor, $event)"
                  />
                  <!-- 左下角缩放点 -->
                  <circle
                    cx="-25" cy="35" r="4"
                    fill="#1890ff" stroke="white" stroke-width="2"
                    class="resize-handle"
                    @mousedown.stop="onResizeStart(actor, $event)"
                  />
                </g>
              </g>
            </g>

          </svg>
            </div>
          </div>
      </div>
    </div>

    <!-- 系统业务描述查看弹框 -->
    <el-dialog
      title="系统业务描述"
      :visible.sync="showDescDialog"
      width="500px"
    >
      <div style="white-space: pre-wrap; line-height: 1.8; font-size: 14px; color: #333; height: 300px; overflow-y: auto; padding: 4px 8px;">{{ currentDesc }}</div>
      <span slot="footer">
        <el-button @click="showDescDialog = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 历史泳道图弹框 -->
    <el-dialog
      title="历史泳道图"
      :visible.sync="showHistoryModal"
      width="1200px"
      :before-close="closeHistoryDialog"
    >
      <div class="history-content">

        <!-- 说明 -->
        <div class="history-description" style="margin-bottom: 12px;">
          <ul>
            <li>• 共有 {{ savedDiagrams.length }} 个已保存的泳道图（按保存时间倒序排列）</li>
            <li>• 点击"加载"按钮可以加载对应的泳道图</li>
            <li>• 系统最多保存20条历史泳道图记录</li>
          </ul>
        </div>

        <el-table
          :data="reversedSavedDiagrams"
          stripe
          style="width: 100%"
          :row-class-name="getRowClassName"
          empty-text="暂无保存的历史泳道图"
        >
          <el-table-column type="index" label="序号" width="55" align="center" />

          <el-table-column label="课题名称" min-width="120" align="center">
            <template slot-scope="scope">
              <span class="diagram-name" :class="{ current: currentDiagramId === scope.row.id }">
                {{ scope.row.projectName || '-' }}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="角色" width="150" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.actors || '-' }}</span>
            </template>
          </el-table-column>

          <el-table-column label="系统业务描述" width="130" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.functionDescription"
                size="mini"
                type="text"
                @click="viewFunctionDescription(scope.row.functionDescription)"
              >查看</el-button>
              <span v-else style="color:#ccc;">-</span>
            </template>
          </el-table-column>


          <el-table-column label="保存时间" width="155" align="center">
            <template slot-scope="scope">
              <div class="absolute-time">{{ formatAbsoluteTime(scope.row.timestamp) }}</div>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="180" align="center" fixed="right">
            <template slot-scope="scope">
              <div class="action-buttons">
                <el-button size="mini" type="primary" @click="loadDiagramFromHistory(scope.row)">加载</el-button>
                <el-button size="mini" type="danger" @click="deleteDiagramFromHistory(getOriginalIndex(scope.row))">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :total="savedDiagrams.length"
            @current-change="handlePageChange"
            layout="prev, pager, next"
          />
        </div>
      </div>
    </el-dialog>

    <!-- 导出对话框 -->
    <ExportDialog
        :visible.sync="isExportDialogVisible"
        @confirm="handleExportConfirm"
    />

  </div>
</template>

<script>
import ExportDialog from '@/components/ExportDialog.vue'

export default {
  name: "yonglitu",
  components: {
    ExportDialog
  },
  data() {
    return {
      // 画布元素
      actors: [],
      useCases: [],
      boundaries: [],
      relationships: [],
      hoveredLine: null,

      // 拖拽状态
      isDragging: false,
      dragOffset: { x: 0, y: 0 },
      selectedElement: null,

      // 缩放状态
      isResizing: false,
      resizeType: null,
      resizeStartPos: { x: 0, y: 0 },
      originalSize: { width: 0, height: 0, scale: 1 },

      // 线条端点拖拽状态
      isDraggingEndpoint: false,
      draggingEndpoint: null, // 'start' 或 'end'
      draggingLine: null,

      // 线条拖拽状态
      isDraggingLine: false,

      // 文字拖拽状态
      isDraggingText: false,
      textDragOffset: { x: 0, y: 0 },
      preventTextEdit: false,

      // 内联编辑
      editingElement: null,
      editingText: '',

      // ID计数器
      nextId: 1,

      // 参数设置
      fontFamily: 'SimSun',
      fontSize: 22,
      fontWeight: 'normal',
      fontColor: '#333333',
      lineColor: '#333333',
      lineWidth: 1,
      arrowSize: 'medium',

      // 全屏状态
      isFullscreen: false,

      // 保存管理
      savedDiagrams: [],
      currentDiagramId: null,
      showHistoryModal: false,
      showDescDialog: false,
      currentDesc: '',

      // 积分配置
      pointsConfig: {
        swimlaneDiagram: 3
      },

      // 分页
      currentPage: 1,
      pageSize: 10,

      aiForm: {
        projectName: '',
        moduleName: '',
        actors: '',
        actorList: [],
        functionDescription: ''
      },
      actorInputVisible: false,
      actorInputValue: '',

      // 画布平移
      isPanning: false,
      panStartX: 0,
      panStartY: 0,
      panX: 0,
      panY: 0,
      canvasVirtualWidth: 1300,
      canvasVirtualHeight: 1000,
      zoomLevel: 1,

      // 导出对话框
      isExportDialogVisible: false
    }
  },
  methods: {
    increasePageView() {
      this.request.get('/pageView/increase', {
        params: { pageName: 'swimlane' }
      }).catch(() => {})
    },

    // 加载积分配置
    async loadPointsConfig() {
      try {
        const response = await this.request.get('/ai/points-config')
        if (response.code === '200' && response.data) {
          this.pointsConfig = response.data
        }
      } catch (error) {
        console.error('加载积分配置失败:', error)
      }
    },

    // 刷新积分
    refreshPoints() {
      // 使用全局方法刷新积分
      this.$refreshPoints()
    },

    // 元素鼠标按下
    onElementMouseDown(element, event) {
      // 选中元素并立即开始拖拽
      this.selectedElement = element;
      this.isDragging = true;

      // 如果正在编辑其他元素，先保存编辑
      if (this.editingElement && this.editingElement.id !== element.id) {
        this.saveEdit();
      }

      var rect = this.$refs.diagramSvg.getBoundingClientRect();
      // 普通元素的拖拽偏移计算（考虑viewBox偏移和缩放）
      var scaleX = (this.canvasVirtualWidth / this.zoomLevel) / rect.width;
      var scaleY = (this.canvasVirtualHeight / this.zoomLevel) / rect.height;
      this.dragOffset = {
        x: (event.clientX - rect.left) * scaleX - this.panX - element.x,
        y: (event.clientY - rect.top) * scaleY - this.panY - element.y
      };

      event.stopPropagation();
    },

    // 画布鼠标移动
    onCanvasMouseMove(event) {
      // 处理画布平移
      if (this.isPanning) {
        const dx = event.clientX - this.panStartX;
        const dy = event.clientY - this.panStartY;
        // 将屏幕像素转换为SVG坐标系的移动量（考虑缩放）
        const rect = this.$refs.diagramSvg.getBoundingClientRect();
        const scaleX = (this.canvasVirtualWidth / this.zoomLevel) / rect.width;
        const scaleY = (this.canvasVirtualHeight / this.zoomLevel) / rect.height;
        this.panX += dx * scaleX;
        this.panY += dy * scaleY;
        this.panStartX = event.clientX;
        this.panStartY = event.clientY;
        return;
      }

      // 如果鼠标不在任何连接线上，清除悬停状态
      if (event.target === this.$refs.diagramSvg && this.hoveredLine && !this.isDragging && !this.isDraggingLine && !this.isDraggingEndpoint) {
        this.hoveredLine = null;
      }

      var rect = this.$refs.diagramSvg.getBoundingClientRect();
      // 将屏幕坐标转换为SVG坐标（考虑viewBox偏移和缩放）
      var scaleX = (this.canvasVirtualWidth / this.zoomLevel) / rect.width;
      var scaleY = (this.canvasVirtualHeight / this.zoomLevel) / rect.height;
      var currentX = (event.clientX - rect.left) * scaleX - this.panX;
      var currentY = (event.clientY - rect.top) * scaleY - this.panY;

      // 处理线条端点拖拽
      if (this.isDraggingEndpoint && this.draggingLine) {
        if (this.draggingEndpoint === 'start') {
          this.draggingLine.x1 = currentX;
          this.draggingLine.y1 = currentY;
        } else if (this.draggingEndpoint === 'end') {
          this.draggingLine.x2 = currentX;
          this.draggingLine.y2 = currentY;
        }
      }

      // 处理线条整体拖拽
      if (this.isDraggingLine && this.selectedElement) {
        var isLineType = this.selectedElement.type === 'arrow-line' ||
                        this.selectedElement.type === 'straight-line' ||
                        this.selectedElement.type === 'dashed-arrow-line' ||
                        this.selectedElement.type === 'dashed-straight-line' ||
                        this.selectedElement.type === 'generalization-line';

        if (isLineType) {
          var deltaX = currentX - this.dragOffset.x;
          var deltaY = currentY - this.dragOffset.y;

          this.selectedElement.x1 += deltaX;
          this.selectedElement.x2 += deltaX;
          this.selectedElement.y1 += deltaY;
          this.selectedElement.y2 += deltaY;

          // 更新拖拽偏移
          this.dragOffset.x = currentX;
          this.dragOffset.y = currentY;
        }
      }

      // 处理文字拖拽
      if (this.isDraggingText && this.selectedElement && (this.selectedElement.type === 'boundary' || this.selectedElement.type === 'solid-boundary')) {
        var newTextX = currentX - this.textDragOffset.x;
        var newTextY = currentY - this.textDragOffset.y;

        // 限制文字在边界框外部一点的范围内
        var extraSpace = 30; // 允许文字超出边界框30px
        var minTextX = this.selectedElement.x - this.selectedElement.width/2 - extraSpace;
        var maxTextX = this.selectedElement.x + this.selectedElement.width/2 + extraSpace;
        var minTextY = this.selectedElement.y - this.selectedElement.height/2 - extraSpace;
        var maxTextY = this.selectedElement.y + this.selectedElement.height/2 + extraSpace;

        this.selectedElement.textX = Math.max(minTextX, Math.min(maxTextX, newTextX));
        this.selectedElement.textY = Math.max(minTextY, Math.min(maxTextY, newTextY));
      }

      // 处理拖拽移动
      if (this.isDragging && this.selectedElement && !this.isResizing && !this.isDraggingEndpoint && !this.isDraggingLine && !this.isDraggingText) {
        // 普通元素拖拽移动
        var newX = currentX - this.dragOffset.x;
        var newY = currentY - this.dragOffset.y;

        // 边界检查（使用虚拟画布尺寸）
        var minX = this.selectedElement.type === 'actor' ? 25 : (this.selectedElement.width || 0) / 2;
        var minY = this.selectedElement.type === 'actor' ? 35 : (this.selectedElement.height || 0) / 2;
        var maxX = this.canvasVirtualWidth - minX;
        var maxY = this.canvasVirtualHeight - minY;

        var oldX = this.selectedElement.x;
        var oldY = this.selectedElement.y;

        this.selectedElement.x = Math.max(minX, Math.min(maxX, newX));
        this.selectedElement.y = Math.max(minY, Math.min(maxY, newY));

        // 如果是系统边界，同步移动文字位置
        if (this.selectedElement.type === 'boundary' || this.selectedElement.type === 'solid-boundary') {
          var deltaX = this.selectedElement.x - oldX;
          var deltaY = this.selectedElement.y - oldY;
          this.selectedElement.textX += deltaX;
          this.selectedElement.textY += deltaY;
        }

        // 更新相关的关系线
        this.updateRelationships();
      }

      // 处理缩放
      if (this.isResizing && this.selectedElement) {
        var deltaX = currentX - this.resizeStartPos.x;
        var deltaY = currentY - this.resizeStartPos.y;

        if (this.selectedElement.type === 'actor') {
          // 参与者缩放 (使用scale属性)
          var scaleFactor = 1 + deltaY / 100; // 根据Y轴移动调整缩放
          this.selectedElement.scale = Math.max(0.5, Math.min(2, scaleFactor));
        } else if (this.selectedElement.type === 'usecase') {
          // 节点缩放 (调整width和height)
          if (this.resizeType === 'width' || this.resizeType === 'both') {
            this.selectedElement.width = Math.max(60, this.originalSize.width + deltaX * 2);
          }
          if (this.resizeType === 'height' || this.resizeType === 'both') {
            this.selectedElement.height = Math.max(30, this.originalSize.height + deltaY * 2);
          }
        } else if (this.selectedElement.type === 'boundary' || this.selectedElement.type === 'solid-boundary') {
          // 系统边界缩放 (调整width和height)
          if (this.resizeType === 'width' || this.resizeType === 'both') {
            this.selectedElement.width = Math.max(100, this.originalSize.width + deltaX * 2);
          }
          if (this.resizeType === 'height' || this.resizeType === 'both') {
            this.selectedElement.height = Math.max(50, this.originalSize.height + deltaY * 2);
          }

          // 确保文字位置在新的边界范围内
          var extraSpace = 30; // 允许文字超出边界框30px
          var minTextX = this.selectedElement.x - this.selectedElement.width/2 - extraSpace;
          var maxTextX = this.selectedElement.x + this.selectedElement.width/2 + extraSpace;
          var minTextY = this.selectedElement.y - this.selectedElement.height/2 - extraSpace;
          var maxTextY = this.selectedElement.y + this.selectedElement.height/2 + extraSpace;

          this.selectedElement.textX = Math.max(minTextX, Math.min(maxTextX, this.selectedElement.textX));
          this.selectedElement.textY = Math.max(minTextY, Math.min(maxTextY, this.selectedElement.textY));
        }
      }
    },

    // 画布鼠标释放
    onCanvasMouseUp() {
      this.isDragging = false;
      this.isResizing = false;
      this.resizeType = null;
      this.isDraggingEndpoint = false;
      this.draggingEndpoint = null;
      this.draggingLine = null;
      this.isDraggingLine = false;
      this.isDraggingText = false;
      this.isPanning = false;
    },

    // 画布点击事件
    onCanvasClick(event) {
      if (event.target === event.currentTarget) {
        this.clearSelection();
      }
    },

    // 画布鼠标按下（用于取消选择或开始平移）
    onCanvasMouseDown(event) {
      if (event.target === this.$refs.diagramSvg) {
        // 如果正在编辑，先保存编辑
        if (this.editingElement) {
          this.saveEdit();
        }
        this.clearSelection();
        // 空白处按下，开始平移
        this.isPanning = true;
        this.panStartX = event.clientX;
        this.panStartY = event.clientY;
        event.preventDefault();
      }
    },

    // 清除选择
    clearSelection() {
      // 如果正在编辑，先保存编辑
      if (this.editingElement) {
        this.saveEdit();
      }
      this.selectedElement = null;
      this.hoveredLine = null;
    },

    // 删除元素
    deleteElement(element) {
      var vm = this;
      if (element.type === 'actor') {
        var index = this.actors.findIndex(function(a) { return a.id === element.id; });
        if (index > -1) {
          this.actors.splice(index, 1);
        }
      } else if (element.type === 'usecase') {
        var index = this.useCases.findIndex(function(u) { return u.id === element.id; });
        if (index > -1) {
          this.useCases.splice(index, 1);
        }
      } else if (element.type === 'boundary' || element.type === 'solid-boundary') {
        var index = this.boundaries.findIndex(function(b) { return b.id === element.id; });
        if (index > -1) {
          this.boundaries.splice(index, 1);
        }
      } else if (element.type === 'arrow-line' || element.type === 'straight-line' || element.type === 'dashed-arrow-line' || element.type === 'dashed-straight-line' || element.type === 'generalization-line') {
        var index = this.relationships.findIndex(function(r) { return r.id === element.id; });
        if (index > -1) {
          this.relationships.splice(index, 1);
        }
      }

      // 删除相关的关系线
      this.relationships = this.relationships.filter(function(rel) {
        return rel.fromId !== element.id && rel.toId !== element.id;
      });

      this.selectedElement = null;
    },

    // 缩放开始
    onResizeStart(element, event, type) {
      this.isResizing = true;
      this.resizeType = type || 'scale';
      this.selectedElement = element;

      var rect = this.$refs.diagramSvg.getBoundingClientRect();
      var scaleX = (this.canvasVirtualWidth / this.zoomLevel) / rect.width;
      var scaleY = (this.canvasVirtualHeight / this.zoomLevel) / rect.height;
      this.resizeStartPos = {
        x: (event.clientX - rect.left) * scaleX - this.panX,
        y: (event.clientY - rect.top) * scaleY - this.panY
      };

      // 保存原始大小
      if (element.type === 'actor') {
        this.originalSize = {
          scale: element.scale || 1
        };
      } else if (element.type === 'usecase') {
        this.originalSize = {
          width: element.width,
          height: element.height
        };
      } else if (element.type === 'boundary' || element.type === 'solid-boundary') {
        this.originalSize = {
          width: element.width,
          height: element.height
        };
      }

      event.stopPropagation();
    },

    // 开始拖拽端点
    startEndpointDrag(line, endpoint, event) {
      this.isDraggingEndpoint = true;
      this.draggingEndpoint = endpoint;
      this.draggingLine = line;
      this.selectedElement = line;
      event.stopPropagation();
    },

    // 开始拖拽整条线条
    startLineDrag(line, event) {
      this.isDraggingLine = true;
      this.selectedElement = line;

      var rect = this.$refs.diagramSvg.getBoundingClientRect();
      var scaleX = (this.canvasVirtualWidth / this.zoomLevel) / rect.width;
      var scaleY = (this.canvasVirtualHeight / this.zoomLevel) / rect.height;
      this.dragOffset = {
        x: (event.clientX - rect.left) * scaleX - this.panX,
        y: (event.clientY - rect.top) * scaleY - this.panY
      };

      event.stopPropagation();
    },

    // 选中线条
    selectLine(line) {
      this.selectedElement = line;
      if (this.editingElement && this.editingElement.id !== line.id) {
        this.saveEdit();
      }
    },

    // 设置悬停线条
    setHoveredLine(line) {
      this.hoveredLine = line;
    },

    // 清除悬停线条
    clearHoveredLine() {
      this.hoveredLine = null;
    },

    // 折线生成 SVG path d 属性（支持 marker-end）
    getPolylinePath(rel) {
      const pts = [[rel.x1, rel.y1], ...(rel.waypoints || []).map(p => [p.x, p.y]), [rel.x2, rel.y2]];
      return pts.map((p, i) => `${i === 0 ? 'M' : 'L'}${p[0]},${p[1]}`).join(' ');
    },

    // 标签 x
    getLabelX(rel) {
      if (rel.waypoints && rel.waypoints.length) {
        return (rel.x1 + rel.waypoints[0].x) / 2 + 8;
      }
      return rel.x1 === rel.x2 ? rel.x1 - 16 : (rel.x1 + rel.x2) / 2;
    },

    // 标签 y
    getLabelY(rel) {
      if (rel.waypoints && rel.waypoints.length) {
        return (rel.y1 + rel.waypoints[0].y) / 2 - 8;
      }
      return rel.y1 === rel.y2 ? rel.y1 - 8 : (rel.y1 + rel.y2) / 2 - 8;
    },

    // 获取箭头标记
    getMarkerEnd(rel) {
      if (!rel.hasArrow || this.arrowSize === 'none') {
        return 'none';
      }
      if (rel.isHollow) {
        return 'url(#hollow-arrowhead)';
      }
      return 'url(#arrowhead)';
    },

    // 删除文字
    deleteText(element) {
      element.label = '';
    },

    // 开始文字拖拽
    startTextDrag(boundary, event) {
      this.selectedElement = boundary;
      this.isDraggingText = true;

      var rect = this.$refs.diagramSvg.getBoundingClientRect();
      var scaleX = (this.canvasVirtualWidth / this.zoomLevel) / rect.width;
      var scaleY = (this.canvasVirtualHeight / this.zoomLevel) / rect.height;
      var svgX = (event.clientX - rect.left) * scaleX - this.panX;
      var svgY = (event.clientY - rect.top) * scaleY - this.panY;
      this.textDragOffset = {
        x: svgX - boundary.textX,
        y: svgY - boundary.textY
      };

      // 防止触发编辑
      this.preventTextEdit = true;
      var vm = this;
      setTimeout(function() {
        vm.preventTextEdit = false;
      }, 200);

      event.stopPropagation();
    },

    // 开始编辑
    startEdit(element) {
      // 如果正在拖拽文字，不进入编辑模式
      if (this.preventTextEdit) {
        return;
      }

      console.log('开始编辑:', element.name || element.label);
      this.editingElement = element;
      this.editingText = element.name || element.label || '';
      this.selectedElement = element;

      // 使用setTimeout确保DOM更新后再聚焦
      var vm = this;
      setTimeout(function() {
        var inputRef = vm.$refs['editInput_' + element.id];
        console.log('查找输入框:', 'editInput_' + element.id, inputRef);
        if (inputRef && inputRef[0]) {
          inputRef[0].focus();
          inputRef[0].select();
          console.log('输入框已聚焦');
        }
      }, 50);
    },

    // 保存编辑
    saveEdit() {
      console.log('保存编辑:', this.editingText);
      if (this.editingElement) {
        if (this.editingElement.name !== undefined) {
          // 参与者和节点使用name属性
          if (this.editingText && this.editingText.trim()) {
            this.editingElement.name = this.editingText.trim();
          }
        } else if (this.editingElement.label !== undefined) {
          // 连接线使用label属性，允许设置为空
          this.editingElement.label = this.editingText ? this.editingText.trim() : '';
        }
      }
      this.editingElement = null;
      this.editingText = '';
    },

    // 取消编辑
    cancelEdit() {
      console.log('取消编辑');
      this.editingElement = null;
      this.editingText = '';
    },

    // 更新关系线端点（元素移动时调用）
    updateRelationships() {
      this.relationships.forEach(rel => {
        const fromEl = rel.fromId ? this.findElementById(rel.fromId) : null;
        const toEl   = rel.toId   ? this.findElementById(rel.toId)   : null;

        if (fromEl) {
          const pt = this.getElementConnectionPoint(fromEl, rel.fromSide || 'bottom');
          rel.x1 = pt.x; rel.y1 = pt.y;
        }
        if (toEl) {
          const pt = this.getElementConnectionPoint(toEl, rel.toSide || 'top');
          rel.x2 = pt.x; rel.y2 = pt.y;
        }

        // waypoints 联动：正交折线拐点跟随端点更新
        if (rel.waypoints && rel.waypoints.length > 0) {
          const fromSide = rel.fromSide || 'bottom';
          const toSide   = rel.toSide   || 'top';

          if (rel.waypoints.length === 1) {
            if ((fromSide === 'right' || fromSide === 'left') && (toSide === 'right' || toSide === 'left')) {
              rel.waypoints[0].x = rel.x2;
              rel.waypoints[0].y = rel.y1;
            } else if (fromSide === 'bottom' || fromSide === 'top') {
              rel.waypoints[0].x = rel.x1;
              rel.waypoints[0].y = rel.y2;
            }
          } else if (rel.waypoints.length === 2) {
            // 同侧出入（right→right 或 left→left）：固定30px偏移绕行
            if (fromSide === 'right' && toSide === 'right') {
              const ox = Math.max(rel.x1, rel.x2) + 30;
              rel.waypoints[0].x = ox; rel.waypoints[0].y = rel.y1;
              rel.waypoints[1].x = ox; rel.waypoints[1].y = rel.y2;
            } else if (fromSide === 'left' && toSide === 'left') {
              const ox = Math.min(rel.x1, rel.x2) - 30;
              rel.waypoints[0].x = ox; rel.waypoints[0].y = rel.y1;
              rel.waypoints[1].x = ox; rel.waypoints[1].y = rel.y2;
            } else {
              rel.waypoints[0].x = rel.x1;
              rel.waypoints[0].y = rel.y2;
              rel.waypoints[1].x = rel.x2;
              rel.waypoints[1].y = rel.y2;
            }
          }
        }
      });
    },

    findElementById(id) {
      return this.actors.find(a => a.id === id) ||
             this.boundaries.find(b => b.id === id) ||
             null
    },

    getElementConnectionPoint(el, side) {
      const w = (el.width || 0) / 2
      const h = (el.height || 0) / 2
      const scale = el.scale || 1
      const aw = el.type === 'actor' ? 20 * scale : w
      const ah = el.type === 'actor' ? 40 * scale : h
      switch (side) {
        case 'top':    return { x: el.x,      y: el.y - ah }
        case 'bottom': return { x: el.x,      y: el.y + ah }
        case 'left':   return { x: el.x - aw, y: el.y }
        case 'right':  return { x: el.x + aw, y: el.y }
        default:       return { x: el.x,      y: el.y }
      }
    },

    // 根据线条端点坐标自动推断 fromId/toId（兼容旧数据）
    inferRelationshipIds() {
      const allElements = [...this.actors, ...this.useCases, ...this.boundaries]
      if (allElements.length === 0) return
      this.relationships.forEach(rel => {
        if (rel.fromId && rel.toId) return
        // 找距离 (x1,y1) 最近的元素
        if (!rel.fromId) {
          let minD = Infinity; let closest = null
          allElements.forEach(el => {
            const d = Math.hypot(el.x - rel.x1, el.y - rel.y1)
            if (d < minD) { minD = d; closest = el }
          })
          if (closest && minD < 300) {
            rel.fromId = closest.id
            const dx = rel.x1 - closest.x
            const dy = rel.y1 - closest.y
            if (Math.abs(dy) > Math.abs(dx)) {
              rel.fromSide = dy > 0 ? 'bottom' : 'top'
            } else {
              rel.fromSide = dx > 0 ? 'right' : 'left'
            }
          }
        }
        // 找距离 (x2,y2) 最近的元素
        if (!rel.toId) {
          let minD = Infinity; let closest = null
          allElements.forEach(el => {
            const d = Math.hypot(el.x - rel.x2, el.y - rel.y2)
            if (d < minD) { minD = d; closest = el }
          })
          if (closest && minD < 300) {
            rel.toId = closest.id
            const dx = rel.x2 - closest.x
            const dy = rel.y2 - closest.y
            if (Math.abs(dy) > Math.abs(dx)) {
              rel.toSide = dy > 0 ? 'bottom' : 'top'
            } else {
              rel.toSide = dx > 0 ? 'right' : 'left'
            }
          }
        }
      })
    },

    // 清空画布
    clearCanvas() {
      var vm = this;
      this.$confirm('确定要清空画布吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function() {
                         vm.actors = [];
        vm.boundaries = [];
        vm.relationships = [];
         vm.selectedElement = null;
         vm.hoveredLine = null;
         vm.editingElement = null;
         vm.editingText = '';
         vm.currentDiagramId = null;
      }).catch(function() {});
    },

    // 打开导出对话框
    openExportDialog() {
      if (!this.canSave) {
        this.$message.warning('没有可导出的内容');
        return;
      }
      this.isExportDialogVisible = true;
    },

    // 处理导出确认
    handleExportConfirm(options) {
      if (options.format === 'drawio') {
        this.exportToDrawio();
      } else {
        this.downloadImage(options.background);
      }
    },

    // 导出为 Draw.io 格式
    exportToDrawio() {
      try {
        const cells = [];
        let idCounter = 2;
        const idMap = {};
        const fs = this.fontSize;
        const ff = this.fontFamily;
        const lc = this.lineColor.replace('#', '');
        const lw = this.lineWidth;

        const poolBoundary = this.boundaries.find(b => b.isPool);
        const lanes = this.boundaries.filter(b => b.isLane);

        // Pool 绝对坐标左上角
        const poolAbsX = poolBoundary ? Math.round(poolBoundary.x - poolBoundary.width / 2) : 0;
        const poolAbsY = poolBoundary ? Math.round(poolBoundary.y - poolBoundary.height / 2) : 0;
        const poolTitleW = poolBoundary ? (poolBoundary.poolTitleW || 30) : 0;
        const poolW = poolBoundary ? Math.round(poolBoundary.width) : 0;
        const poolH = poolBoundary ? Math.round(poolBoundary.height) : 0;

        // ── 1. Pool ───────────────────────────────────────────────────────
        let poolCellId = 1;
        if (poolBoundary) {
          poolCellId = idCounter;
          idMap[poolBoundary.id] = idCounter;
          // 不用 childLayout=stackLayout，Lane 手动定位，避免右侧多出空白
          cells.push(
            `<mxCell id="${idCounter}" value="${this.escapeXml(poolBoundary.name)}" vertex="1" parent="1"` +
            ` style="swimlane;horizontal=0;startSize=${poolTitleW};` +
            `fontSize=${fs};fontFamily=${ff};strokeColor=#${lc};strokeWidth=${lw};">` +
            `<mxGeometry x="${poolAbsX}" y="${poolAbsY}" width="${poolW}" height="${poolH}" as="geometry"/>` +
            `</mxCell>`
          );
          idCounter++;
        }

        // ── 2. Lane：parent=Pool，x 从 poolTitleW 开始，y=0 ─────────────
        // Pool horizontal=0 时，子元素坐标相对于 Pool 左上角
        lanes.forEach((lane, idx) => {
          idMap[lane.id] = idCounter;
          const laneW = Math.round(lane.width);
          const lx = poolTitleW + idx * laneW;  // 从标题栏右边开始
          cells.push(
            `<mxCell id="${idCounter}" value="${this.escapeXml(lane.name)}" vertex="1" parent="${poolCellId}"` +
            ` style="swimlane;startSize=30;fontSize=${fs};fontFamily=${ff};` +
            `strokeColor=#${lc};strokeWidth=${lw};">` +
            `<mxGeometry x="${lx}" y="0" width="${laneW}" height="${poolH}" as="geometry"/>` +
            `</mxCell>`
          );
          idCounter++;
        });

        // ── 3. 节点：parent=所属Lane，坐标相对于 Lane ────────────────────
        // drawio swimlane 子元素坐标：x/y 相对于 Lane 左上角（含标题栏）
        // 节点实际显示在标题栏下方，所以 ny = node绝对y - lane绝对y（不减laneHeaderH）
        this.boundaries.filter(b => b.isNode).forEach(node => {
          idMap[node.id] = idCounter;
          const lane = lanes.find(b =>
            node.x >= b.x - b.width / 2 && node.x <= b.x + b.width / 2);
          const parentId = lane ? idMap[lane.id] : poolCellId;
          const laneAbsX = lane ? lane.x - lane.width / 2 : poolAbsX + poolTitleW;
          const laneAbsY = lane ? lane.y - lane.height / 2 : poolAbsY;
          const nx = Math.round(node.x - node.width / 2 - laneAbsX);
          // Lane 内容区从 startSize(30) 以下开始，节点 y 要减去标题栏高度
          const ny = Math.round(node.y - node.height / 2 - laneAbsY - 30);

          let style;
          if (node.isEllipse) {
            style = `ellipse;whiteSpace=wrap;html=1;aspect=fixed;fontSize=${fs};fontFamily=${ff};strokeColor=#${lc};strokeWidth=${lw};`;
          } else if (node.isDiamond) {
            style = `rhombus;whiteSpace=wrap;html=1;fontSize=${fs};fontFamily=${ff};strokeColor=#${lc};strokeWidth=${lw};`;
          } else {
            style = `rounded=0;whiteSpace=wrap;html=1;fontSize=${fs};fontFamily=${ff};strokeColor=#${lc};strokeWidth=${lw};`;
          }
          cells.push(
            `<mxCell id="${idCounter}" value="${this.escapeXml(node.name)}" vertex="1" parent="${parentId}" style="${style}">` +
            `<mxGeometry x="${nx}" y="${ny}" width="${Math.round(node.width)}" height="${Math.round(node.height)}" as="geometry"/>` +
            `</mxCell>`
          );
          idCounter++;
        });

        // ── 4. 参与者 ─────────────────────────────────────────────────────
        this.actors.forEach(actor => {
          idMap[actor.id] = idCounter;
          cells.push(
            `<mxCell id="${idCounter}" value="${this.escapeXml(actor.name)}" vertex="1" parent="1"` +
            ` style="shape=umlActor;verticalLabelPosition=bottom;verticalAlign=top;html=1;fontSize=${fs};fontFamily=${ff};">` +
            `<mxGeometry x="${Math.round(actor.x - 30)}" y="${Math.round(actor.y - 40)}" width="60" height="80" as="geometry"/>` +
            `</mxCell>`
          );
          idCounter++;
        });

        // ── 5. 连线：parent="1"，绑定 source/target，让 drawio 自动路由 ──
        const sideToRatio = (side) => {
          switch (side) {
            case 'top':    return { x: 0.5, y: 0 };
            case 'bottom': return { x: 0.5, y: 1 };
            case 'left':   return { x: 0,   y: 0.5 };
            case 'right':  return { x: 1,   y: 0.5 };
            default:       return { x: 0.5, y: 0.5 };
          }
        };

        this.relationships.forEach(rel => {
          const edgeId = idCounter++;
          const srcCellId = rel.fromId != null && idMap[rel.fromId] ? idMap[rel.fromId] : null;
          const tgtCellId = rel.toId   != null && idMap[rel.toId]   ? idMap[rel.toId]   : null;

          // 用正交自动路由，移动节点后连线自动跟随重新路由
          let style = `edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;fontSize=${fs};fontFamily=${ff};strokeColor=#${lc};strokeWidth=${lw};`;
          if (!rel.hasArrow) style += 'endArrow=none;';
          if (rel.isDashed)  style += 'dashed=1;';
          if (rel.isHollow)  style += 'endArrow=block;endFill=0;';
          if (rel.fromSide) { const r = sideToRatio(rel.fromSide); style += `exitX=${r.x};exitY=${r.y};exitDx=0;exitDy=0;`; }
          if (rel.toSide)   { const r = sideToRatio(rel.toSide);   style += `entryX=${r.x};entryY=${r.y};entryDx=0;entryDy=0;`; }

          const srcAttr = srcCellId ? ` source="${srcCellId}"` : '';
          const tgtAttr = tgtCellId ? ` target="${tgtCellId}"` : '';

          // 有 source+target 时不输出 waypoints，让 drawio 自动路由
          // 无 source 或 target 时才用绝对坐标固定端点
          let geomInner = '';
          if (!srcCellId) geomInner += `<mxPoint x="${Math.round(rel.x1)}" y="${Math.round(rel.y1)}" as="sourcePoint"/>`;
          if (!tgtCellId) geomInner += `<mxPoint x="${Math.round(rel.x2)}" y="${Math.round(rel.y2)}" as="targetPoint"/>`;

          const geom = geomInner
            ? `<mxGeometry relative="1" as="geometry">${geomInner}</mxGeometry>`
            : `<mxGeometry relative="1" as="geometry"/>`;

          cells.push(
            `<mxCell id="${edgeId}" value="" edge="1" parent="1"${srcAttr}${tgtAttr} style="${style}">` +
            geom + `</mxCell>`
          );

          // 标签
          if (rel.label && rel.label.trim()) {
            cells.push(
              `<mxCell id="${idCounter++}" value="${this.escapeXml(rel.label)}" connectable="0" vertex="1" parent="${edgeId}"` +
              ` style="edgeLabel;html=1;align=center;verticalAlign=middle;resizable=0;points=[];fontSize=${fs};fontFamily=${ff};">` +
              `<mxGeometry relative="0.5" as="geometry"/>` +
              `</mxCell>`
            );
          }
        });

        // ── 6. 生成 XML ───────────────────────────────────────────────────
        const drawioXml =
`<?xml version="1.0" encoding="UTF-8"?>
<mxfile host="app.diagrams.net" modified="${new Date().toISOString()}" agent="AI泳道图生成器" version="21.0.0" type="device">
  <diagram name="泳道图" id="swimlane-diagram">
    <mxGraphModel dx="1422" dy="794" grid="1" gridSize="10" guides="1" tooltips="1" connect="1" arrows="1" fold="1" page="1" pageScale="1" pageWidth="1169" pageHeight="827" math="0" shadow="0">
      <root>
        <mxCell id="0"/>
        <mxCell id="1" parent="0"/>
        ${cells.join('\n        ')}
      </root>
    </mxGraphModel>
  </diagram>
</mxfile>`;

        const blob = new Blob([drawioXml], { type: 'application/xml;charset=utf-8' });
        const url  = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.download = '泳道图_' + new Date().toISOString().slice(0,19).replace(/[:-]/g,'') + '.drawio';
        link.href = url;
        link.click();
        URL.revokeObjectURL(url);
        this.$message.success('Draw.io 文件导出成功');
      } catch (error) {
        console.error('导出失败:', error);
        this.$message.error('导出失败，请重试');
      }
    },

    // XML 转义
    escapeXml(text) {
      if (!text) return '';
      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;');
    },

    // 下载图片（重命名原来的 exportDiagram）
    downloadImage(background = 'white') {
      const svgElement = this.$refs.diagramSvg;

      if (!svgElement) {
        this.$message.error('未找到泳道图内容');
        return;
      }

      try {
        // 清除选中状态，避免导出时包含选中框
        const originalSelected = this.selectedElement;
        const originalHovered = this.hoveredLine;
        this.selectedElement = null;
        this.hoveredLine = null;

        this.$nextTick(() => {
          try {
            // 获取所有元素的实际边界
            const allElements = [
              ...(this.actors || []),
              ...(this.useCases || []),
              ...(this.boundaries || [])
            ];

            if (allElements.length === 0) {
              this.$message.error('没有可导出的内容');
              this.selectedElement = originalSelected;
              this.hoveredLine = originalHovered;
              return;
            }

            // 计算实际内容的边界
            let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;

            // 检查参与者边界
            if (this.actors && this.actors.length > 0) {
              this.actors.forEach(actor => {
                if (actor && typeof actor.x === 'number' && typeof actor.y === 'number') {
                  const scale = actor.scale || 1;
                  minX = Math.min(minX, actor.x - 60 * scale);
                  maxX = Math.max(maxX, actor.x + 60 * scale);
                  minY = Math.min(minY, actor.y - 30 * scale);
                  maxY = Math.max(maxY, actor.y + 60 * scale);
                }
              });
            }

            // 检查泳道元素边界
            if (this.useCases && this.useCases.length > 0) {
              this.useCases.forEach(usecase => {
                if (usecase && typeof usecase.x === 'number' && typeof usecase.y === 'number') {
                  const width = usecase.width || 100;
                  const height = usecase.height || 40;
                  minX = Math.min(minX, usecase.x - width/2);
                  maxX = Math.max(maxX, usecase.x + width/2);
                  minY = Math.min(minY, usecase.y - height/2);
                  maxY = Math.max(maxY, usecase.y + height/2);
                }
              });
            }

            // 检查系统边界
            if (this.boundaries && this.boundaries.length > 0) {
              this.boundaries.forEach(boundary => {
                if (boundary && typeof boundary.x === 'number' && typeof boundary.y === 'number') {
                  const width = boundary.width || 150;
                  const height = boundary.height || 100;
                  minX = Math.min(minX, boundary.x - width/2);
                  maxX = Math.max(maxX, boundary.x + width/2);
                  minY = Math.min(minY, boundary.y - height/2);
                  maxY = Math.max(maxY, boundary.y + height/2);

                  // 考虑文字位置
                  if (boundary.textX && boundary.textY) {
                    minX = Math.min(minX, boundary.textX - 30);
                    maxX = Math.max(maxX, boundary.textX + 30);
                    minY = Math.min(minY, boundary.textY - 10);
                    maxY = Math.max(maxY, boundary.textY + 10);
                  }
                }
              });
            }

            // 检查连接线边界和标签
            if (this.relationships && this.relationships.length > 0) {
              this.relationships.forEach(rel => {
                if (rel && typeof rel.x1 === 'number' && typeof rel.y1 === 'number') {
                  minX = Math.min(minX, Math.min(rel.x1, rel.x2) - 50);
                  maxX = Math.max(maxX, Math.max(rel.x1, rel.x2) + 50);
                  minY = Math.min(minY, Math.min(rel.y1, rel.y2) - 50);
                  maxY = Math.max(maxY, Math.max(rel.y1, rel.y2) + 50);

                  // 如果有标签，考虑标签的空间
                  if (rel.label && rel.label.trim()) {
                    const labelX = (rel.x1 + rel.x2) / 2;
                    const labelY = (rel.y1 + rel.y2) / 2;
                    minX = Math.min(minX, labelX - 60);
                    maxX = Math.max(maxX, labelX + 60);
                    minY = Math.min(minY, labelY - 20);
                    maxY = Math.max(maxY, labelY + 20);
                  }
                }
              });
            }

            // 添加边距
            const padding = 80;
            minX -= padding;
            minY -= padding;
            maxX += padding;
            maxY += padding;

            // 计算实际需要的尺寸
            const contentWidth = maxX - minX;
            const contentHeight = maxY - minY;

            // 克隆SVG并设置正确的尺寸
            const svgClone = svgElement.cloneNode(true);
            svgClone.setAttribute('width', contentWidth);
            svgClone.setAttribute('height', contentHeight);
            svgClone.setAttribute('viewBox', `${minX} ${minY} ${contentWidth} ${contentHeight}`);
            svgClone.style.width = contentWidth + 'px';
            svgClone.style.height = contentHeight + 'px';

            // 移除所有交互元素
            const elementsToRemove = svgClone.querySelectorAll('.selected, .resize-handle, .endpoint, .text-dragging');
            elementsToRemove.forEach(el => el.remove());

            // 创建临时容器
            const tempContainer = document.createElement('div');
            tempContainer.style.position = 'absolute';
            tempContainer.style.left = '-9999px';
            tempContainer.style.top = '-9999px';
            tempContainer.style.backgroundColor = 'white';
            tempContainer.appendChild(svgClone);
            document.body.appendChild(tempContainer);

            // 转换为图片
            this.svgToImage(svgClone, contentWidth, contentHeight, background).then(dataUrl => {
              // 创建下载链接
              const link = document.createElement('a');
              const timestamp = new Date().toISOString().slice(0, 19).replace(/[:-]/g, '');
              const ext = background === 'transparent' ? 'png' : 'png';
              link.download = '泳道图_' + timestamp + '.' + ext;
              link.href = dataUrl;
              link.click();

              // 清理
              document.body.removeChild(tempContainer);
              this.$message.success('图片导出成功');

              // 恢复选中状态
              this.selectedElement = originalSelected;
              this.hoveredLine = originalHovered;

            }).catch(error => {
              console.error('导出失败:', error);
              document.body.removeChild(tempContainer);
              this.$message.error('导出失败，请重试');

              // 恢复选中状态
              this.selectedElement = originalSelected;
              this.hoveredLine = originalHovered;
            });

          } catch (error) {
            console.error('导出失败:', error);
            this.$message.error('导出失败，请重试');
            this.selectedElement = originalSelected;
            this.hoveredLine = originalHovered;
          }
        });

      } catch (error) {
        console.error('导出失败:', error);
        this.$message.error('导出失败，请重试');
      }
    },

    // SVG转图片 - 从HelloWorld.vue复制
    svgToImage(svgElement, width, height, background = 'white') {
      return new Promise((resolve, reject) => {
        // 获取SVG的XML字符串
        let svgData = new XMLSerializer().serializeToString(svgElement);

        // 添加必要的命名空间
        if (!svgData.includes('xmlns=')) {
          svgData = svgData.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg"');
        }
        if (!svgData.includes('xmlns:xlink=')) {
          svgData = svgData.replace('<svg', '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
        }

        // 创建Canvas
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // 使用3倍分辨率以确保清晰度
        const pixelRatio = 3;

        canvas.width = width * pixelRatio;
        canvas.height = height * pixelRatio;
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';

        // 设置高质量渲染
        ctx.scale(pixelRatio, pixelRatio);
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.textRenderingOptimization = 'optimizeQuality';

        // 设置背景（如果不是透明）
        if (background !== 'transparent') {
          ctx.fillStyle = background;
          ctx.fillRect(0, 0, width, height);
        }

        // 创建Image对象
        const img = new Image();

        img.onload = function () {
          try {
            // 绘制SVG到Canvas
            ctx.drawImage(img, 0, 0, width, height);

            // 导出为高质量PNG
            const dataUrl = canvas.toDataURL('image/png', 1.0);
            resolve(dataUrl);
          } catch (error) {
            reject(error);
          }
        };

        img.onerror = function (error) {
          reject(new Error('图片加载失败: ' + error));
        };

        // 将SVG转换为Data URI
        const blob = new Blob([svgData], {type: 'image/svg+xml;charset=utf-8'});
        const url = URL.createObjectURL(blob);

        img.onload = function () {
          try {
            ctx.drawImage(img, 0, 0, width, height);
            const dataUrl = canvas.toDataURL('image/png', 1.0);
            URL.revokeObjectURL(url); // 清理URL
            resolve(dataUrl);
          } catch (error) {
            URL.revokeObjectURL(url);
            reject(error);
          }
        };

        img.onerror = function () {
          URL.revokeObjectURL(url);
          reject(new Error('图片加载失败'));
        };

                 img.src = url;
       });
     },

     // 放大
     zoomIn() {
       this.zoomLevel = Math.min(3, parseFloat((this.zoomLevel + 0.2).toFixed(1)));
     },

     // 缩小
     zoomOut() {
       this.zoomLevel = Math.max(0.2, parseFloat((this.zoomLevel - 0.2).toFixed(1)));
     },

     // 切换全屏
     toggleFullscreen() {
       const element = document.querySelector('.swimlane-editor');

       if (!this.isFullscreen) {
         // 进入全屏
         if (element.requestFullscreen) {
           element.requestFullscreen();
         } else if (element.webkitRequestFullscreen) {
           element.webkitRequestFullscreen();
         } else if (element.mozRequestFullScreen) {
           element.mozRequestFullScreen();
         } else if (element.msRequestFullscreen) {
           element.msRequestFullscreen();
         }
         this.isFullscreen = true;
       } else {
         // 退出全屏
         if (document.exitFullscreen) {
           document.exitFullscreen();
         } else if (document.webkitExitFullscreen) {
           document.webkitExitFullscreen();
         } else if (document.mozCancelFullScreen) {
           document.mozCancelFullScreen();
         } else if (document.msExitFullscreen) {
           document.msExitFullscreen();
         }
         this.isFullscreen = false;
       }
     },

     // 处理全屏状态变化
     handleFullscreenChange() {
       // 检测是否真的在全屏状态
       this.isFullscreen = !!(
         document.fullscreenElement ||
         document.webkitFullscreenElement ||
         document.mozFullScreenElement ||
         document.msFullscreenElement
       );
     },

    // 更新字体样式
    updateFont() {
      this.$message.success('字体样式已更新');
      // 字体样式会通过computed属性自动应用到元素
    },

        // 更新线条样式
    updateLineStyle() {
      // 线条样式会通过computed属性自动应用到元素
    },

    // 增加线条宽度
    increaseLineWidth() {
      if (this.lineWidth < 5) {
        this.lineWidth += 1;
        this.updateLineStyle();
      }
    },

    // 减少线条宽度
    decreaseLineWidth() {
      if (this.lineWidth > 1) {
        this.lineWidth -= 1;
        this.updateLineStyle();
      }
    },

    // 更新箭头尺寸
    updateArrowSize() {
      // 箭头尺寸会通过computed属性自动应用
    },

    // 保存当前泳道图到localStorage
     saveCurrentDiagram() {
       if (!this.canSave) {
         this.$message.warning('当前泳道图为空，无法保存');
         return;
       }
       if (!this.aiForm.projectName.trim()) {
         this.$message.warning('请填写课题名称');
         return;
       }
       if (!this.aiForm.moduleName.trim()) {
         this.$message.warning('请填写业务流程名称');
         return;
       }
       if (!this.aiForm.actorList || this.aiForm.actorList.length === 0) {
         this.$message.warning('请至少添加一个角色');
         return;
       }
       if (!this.aiForm.functionDescription.trim()) {
         this.$message.warning('请填写系统业务描述');
         return;
       }
       this.doSaveDiagram({
         projectName: this.aiForm.projectName,
         moduleName: this.aiForm.moduleName,
         actors: this.aiForm.actorList.join(','),
         functionDescription: this.aiForm.functionDescription
       });
     },

    // 查看功能描述
    viewFunctionDescription(desc) {
      this.currentDesc = desc;
      this.showDescDialog = true;
    },

    // 执行保存操作
    doSaveDiagram(form) {
      const diagramData = {
        id: 'diagram_' + Date.now(),
        projectName: form.projectName,
        moduleName: form.moduleName,
        actors: form.actors,
        functionDescription: form.functionDescription,
        timestamp: Date.now(),
        actors_data: JSON.parse(JSON.stringify(this.actors || [])),
        useCases: JSON.parse(JSON.stringify(this.useCases || [])),
        boundaries: JSON.parse(JSON.stringify(this.boundaries)),
        relationships: JSON.parse(JSON.stringify(this.relationships)),
        settings: {
          fontFamily: this.fontFamily,
          fontSize: this.fontSize,
          fontWeight: this.fontWeight,
          fontColor: this.fontColor,
          lineColor: this.lineColor,
          lineWidth: this.lineWidth,
          arrowSize: this.arrowSize
        }
      };

      // 获取已保存的泳道图
      let savedDiagrams = this.loadSavedDiagrams();

      // 添加新泳道图
      savedDiagrams.push(diagramData);

      // 如果超过20条，删除最老的
      if (savedDiagrams.length > 20) {
        savedDiagrams.shift();
      }

      this.$message.success('泳道图保存成功');

      // 保存到localStorage
      try {
        localStorage.setItem('swimlane_diagrams', JSON.stringify(savedDiagrams));
        this.savedDiagrams = savedDiagrams;
        this.currentDiagramId = diagramData.id;
      } catch (error) {
        console.error('保存失败:', error);
        this.$message.error('保存失败，可能是存储空间不足');
      }
    },

    // 自动保存泳道图（静默保存）
    autoSaveDiagram() {
      if (!this.canSave) return;
      if (!this.aiForm.projectName.trim()) return;
      if (!this.aiForm.moduleName.trim()) return;
      if (!this.aiForm.actorList || this.aiForm.actorList.length === 0) return;
      if (!this.aiForm.functionDescription.trim()) return;

      const diagramData = {
        id: 'diagram_' + Date.now(),
        projectName: this.aiForm.projectName,
        moduleName: this.aiForm.moduleName,
        actors: this.aiForm.actorList.join(','),
        functionDescription: this.aiForm.functionDescription,
        timestamp: Date.now(),
        actors_data: JSON.parse(JSON.stringify(this.actors || [])),
        useCases: JSON.parse(JSON.stringify(this.useCases || [])),
        boundaries: JSON.parse(JSON.stringify(this.boundaries)),
        relationships: JSON.parse(JSON.stringify(this.relationships)),
        settings: {
          fontFamily: this.fontFamily,
          fontSize: this.fontSize,
          fontWeight: this.fontWeight,
          fontColor: this.fontColor,
          lineColor: this.lineColor,
          lineWidth: this.lineWidth,
          arrowSize: this.arrowSize
        }
      };

      // 获取已保存的泳道图
      let savedDiagrams = this.loadSavedDiagrams();

      // 添加新泳道图
      savedDiagrams.push(diagramData);

      // 如果超过20条，删除最老的
      if (savedDiagrams.length > 20) {
        savedDiagrams.shift();
      }

      // 保存到localStorage
      try {
        localStorage.setItem('swimlane_diagrams', JSON.stringify(savedDiagrams));
        this.savedDiagrams = savedDiagrams;
        this.currentDiagramId = diagramData.id;
      } catch (error) {
        console.error('保存失败:', error);
      }
    },



    // 显示角色输入框
    showActorInput() {
      this.actorInputVisible = true;
      this.$nextTick(() => {
        this.$refs.actorInput && this.$refs.actorInput.focus();
      });
    },

    // 确认添加角色
    confirmActor() {
      const val = this.actorInputValue.trim();
      if (val && !this.aiForm.actorList.includes(val)) {
        this.aiForm.actorList.push(val);
      }
      this.actorInputVisible = false;
      this.actorInputValue = '';
    },

    // 删除角色
    removeActor(index) {
      this.aiForm.actorList.splice(index, 1);
    },
    // 提交AI生成
    submitAIGenerate() {
      // 验证表单
      if (!this.aiForm.projectName.trim()) {
        this.$message.warning('请输入课题名称');
        return;
      }
      if (this.aiForm.actorList.length === 0) {
        this.$message.warning('请至少添加一个角色');
        return;
      }
      if (!this.aiForm.functionDescription.trim()) {
        this.$message.warning('请输入系统业务描述');
        return;
      }

      // 添加积分确认
      this.$confirm(`此操作将消耗${this.pointsConfig.swimlaneDiagram}积分，是否继续？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doAIGenerate();
      }).catch(() => {
        this.$message.info('已取消操作');
      });
    },

    // 执行AI生成
    doAIGenerate() {
      // 显示加载提示
      const loading = this.$loading({
        lock: true,
        text: 'AI正在生成泳道图，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      // 调用后端API生成泳道图
      this.request.post('/ai/generateSwimlane', {
        projectName: this.aiForm.projectName,
        moduleName: this.aiForm.moduleName || this.aiForm.projectName,
        actors: this.aiForm.actorList.join(','),
        functionDescription: this.aiForm.functionDescription
      }).then(res => {
        loading.close();

        if (res.code === '200') {
          // 解析返回的数据
          const data = res.data;

          // 清空当前画布
          this.actors = [];
          this.useCases = [];
          this.boundaries = [];
          this.relationships = [];

          // 加载AI生成的数据
          if (data.actors && Array.isArray(data.actors)) {
            this.actors = data.actors;
          }
          if (data.boundaries && Array.isArray(data.boundaries)) {
            this.boundaries = data.boundaries;
          }
          if (data.relationships && Array.isArray(data.relationships)) {
            this.relationships = data.relationships;
            // 补全 fromId/toId（兼容旧数据和新数据）
            this.$nextTick(() => this.inferRelationshipIds());
          }

          // 更新nextId
          const allIds = [
            ...this.actors.map(a => a.id),
            ...this.boundaries.map(b => b.id),
            ...this.relationships.map(r => r.id)
          ];
          if (allIds.length > 0) {
            this.nextId = Math.max(...allIds) + 1;
          }

          this.$message.success('泳道图生成成功！');

          // 刷新积分
          this.refreshPoints();

          // 自动保存生成的泳道图
          this.$nextTick(() => {
            this.autoSaveDiagram();
          });
        } else {
          this.$message.error(res.msg || '生成失败');
        }
      }).catch(error => {
        loading.close();
        console.error('AI生成失败:', error);
        this.$message.error('生成失败：' + (error.message || '网络错误'));
      });
    },

         // 加载已保存的泳道图列表
     loadSavedDiagrams() {
       try {
         const saved = localStorage.getItem('swimlane_diagrams');
         return saved ? JSON.parse(saved) : [];
       } catch (error) {
         console.error('加载保存的泳道图失败:', error);
         return [];
       }
     },

     // 加载默认示例泳道图（用户下单流程）
     loadDefaultDiagram() {
       const poolTitleW = 30;  // Pool 左侧标题栏宽度
       const laneW = 300, laneH = 1100, offsetX = 20, offsetY = 20;
       const nodeW = 180, nodeH = 50, diaW = 160, diaH = 80;
       // 泳道起始X（Pool标题栏右边开始）
       const laneStartX = offsetX + poolTitleW;
       const cx1 = laneStartX + laneW * 0 + laneW / 2;
       const cx2 = laneStartX + laneW * 1 + laneW / 2;
       const cx3 = laneStartX + laneW * 2 + laneW / 2;
       const cY  = offsetY + laneH / 2;
       // Pool 外框：包含标题栏 + 三条泳道
       const poolW = poolTitleW + laneW * 3;
       const poolCX = offsetX + poolW / 2;
       const R = (n) => 120 + n * 100;

       this.boundaries = [
         // Pool 外框（含左侧竖向标题栏）
         { id: 0,  type: 'boundary', name: this.aiForm.moduleName || '用户下单流程', x: poolCX, y: cY, width: poolW, height: laneH, isDashed: false, isPool: true, poolTitleW },
         // 三条泳道
         { id: 1,  type: 'boundary', name: '用户', x: cx1, y: cY, width: laneW, height: laneH, isDashed: false, isLane: true },
         { id: 2,  type: 'boundary', name: '系统', x: cx2, y: cY, width: laneW, height: laneH, isDashed: false, isLane: true },
         { id: 3,  type: 'boundary', name: '商家', x: cx3, y: cY, width: laneW, height: laneH, isDashed: false, isLane: true },
         { id: 4,  type: 'boundary', name: '开始',          x: cx1, y: R(0), width: 60,    height: 60,    isDashed: false, isEllipse: true, isNode: true },
         { id: 5,  type: 'boundary', name: '提交订单',      x: cx1, y: R(1), width: nodeW, height: nodeH, isDashed: false, isNode: true },
         { id: 6,  type: 'boundary', name: '等待支付',      x: cx1, y: R(2), width: nodeW, height: nodeH, isDashed: false, isNode: true },
         { id: 7,  type: 'boundary', name: '重新支付',      x: cx1, y: R(4), width: nodeW, height: nodeH, isDashed: false, isNode: true },
         { id: 8,  type: 'boundary', name: '确认收货',      x: cx1, y: R(6), width: nodeW, height: nodeH, isDashed: false, isNode: true },
         { id: 9,  type: 'boundary', name: '结束',          x: cx1, y: R(7), width: 60,    height: 60,    isDashed: false, isEllipse: true, isNode: true },
         { id: 10, type: 'boundary', name: '接收订单',      x: cx2, y: R(2), width: nodeW, height: nodeH, isDashed: false, isNode: true },
         { id: 11, type: 'boundary', name: '校验支付信息',  x: cx2, y: R(3), width: nodeW, height: nodeH, isDashed: false, isNode: true },
         { id: 12, type: 'boundary', name: '支付成功？',    x: cx2, y: R(4), width: diaW,  height: diaH,  isDashed: false, isDiamond: true, isNode: true },
         { id: 13, type: 'boundary', name: '生成订单',      x: cx2, y: R(6), width: nodeW, height: nodeH, isDashed: false, isNode: true },
         { id: 14, type: 'boundary', name: '备货发货',      x: cx3, y: R(6), width: nodeW, height: nodeH, isDashed: false, isNode: true },
         { id: 15, type: 'boundary', name: '配送完成',      x: cx3, y: R(7), width: nodeW, height: nodeH, isDashed: false, isNode: true },
         { id: 16, type: 'boundary', name: '结束',          x: cx3, y: R(8), width: 60,    height: 60,    isDashed: false, isEllipse: true, isNode: true },
       ];

       const B   = (id) => this.boundaries.find(b => b.id === id);
       const top = (id) => ({ x: B(id).x,                y: B(id).y - B(id).height / 2 });
       const bot = (id) => ({ x: B(id).x,                y: B(id).y + B(id).height / 2 });
       const lft = (id) => ({ x: B(id).x - B(id).width / 2, y: B(id).y });
       const rgt = (id) => ({ x: B(id).x + B(id).width / 2, y: B(id).y });

       this.relationships = [
         // 用户：开始 → 提交订单 → 等待支付
         { id: 20, fromId: 4,  toId: 5,  fromSide: 'bottom', toSide: 'top',  x1: bot(4).x,  y1: bot(4).y,  x2: top(5).x,  y2: top(5).y,  hasArrow: true, isDashed: false, label: '' },
         { id: 21, fromId: 5,  toId: 6,  fromSide: 'bottom', toSide: 'top',  x1: bot(5).x,  y1: bot(5).y,  x2: top(6).x,  y2: top(6).y,  hasArrow: true, isDashed: false, label: '' },
         // 用户→系统：等待支付 → 接收订单（同行水平）
         { id: 22, fromId: 6,  toId: 10, fromSide: 'right',  toSide: 'left', x1: rgt(6).x,  y1: rgt(6).y,  x2: lft(10).x, y2: lft(10).y, hasArrow: true, isDashed: false, label: '' },
         // 系统：接收订单 → 校验支付信息 → 支付成功？
         { id: 23, fromId: 10, toId: 11, fromSide: 'bottom', toSide: 'top',  x1: bot(10).x, y1: bot(10).y, x2: top(11).x, y2: top(11).y, hasArrow: true, isDashed: false, label: '' },
         { id: 24, fromId: 11, toId: 12, fromSide: 'bottom', toSide: 'top',  x1: bot(11).x, y1: bot(11).y, x2: top(12).x, y2: top(12).y, hasArrow: true, isDashed: false, label: '' },
         // 系统判断否 → 重新支付（菱形左出，同行水平直接连）
         { id: 25, fromId: 12, toId: 7,  fromSide: 'left', toSide: 'right',
           x1: lft(12).x, y1: lft(12).y, x2: rgt(7).x, y2: rgt(7).y,
           hasArrow: true, isDashed: false, label: '否' },
         // 用户：重新支付 → 等待支付（左侧绕行回退）
         { id: 26, fromId: 7,  toId: 6,  fromSide: 'left', toSide: 'left',
           x1: lft(7).x, y1: lft(7).y, x2: lft(6).x, y2: lft(6).y,
           waypoints: [
             { x: lft(7).x - 30, y: lft(7).y },
             { x: lft(7).x - 30, y: lft(6).y }
           ],
           hasArrow: true, isDashed: false, label: '' },
         // 系统判断是 → 生成订单
         { id: 27, fromId: 12, toId: 13, fromSide: 'bottom', toSide: 'top',  x1: bot(12).x, y1: bot(12).y, x2: top(13).x, y2: top(13).y, hasArrow: true, isDashed: false, label: '是' },
         // 系统→用户：生成订单 → 确认收货（同行水平）
         { id: 28, fromId: 13, toId: 8,  fromSide: 'left',   toSide: 'right', x1: lft(13).x, y1: lft(13).y, x2: rgt(8).x,  y2: rgt(8).y,  hasArrow: true, isDashed: false, label: '' },
         // 系统→商家：生成订单 → 备货发货（同行水平）
         { id: 29, fromId: 13, toId: 14, fromSide: 'right',  toSide: 'left',  x1: rgt(13).x, y1: rgt(13).y, x2: lft(14).x, y2: lft(14).y, hasArrow: true, isDashed: false, label: '' },
         // 用户：确认收货 → 结束
         { id: 30, fromId: 8,  toId: 9,  fromSide: 'bottom', toSide: 'top',  x1: bot(8).x,  y1: bot(8).y,  x2: top(9).x,  y2: top(9).y,  hasArrow: true, isDashed: false, label: '' },
         // 商家：备货发货 → 配送完成 → 结束
         { id: 31, fromId: 14, toId: 15, fromSide: 'bottom', toSide: 'top',  x1: bot(14).x, y1: bot(14).y, x2: top(15).x, y2: top(15).y, hasArrow: true, isDashed: false, label: '' },
         { id: 32, fromId: 15, toId: 16, fromSide: 'bottom', toSide: 'top',  x1: bot(15).x, y1: bot(15).y, x2: top(16).x, y2: top(16).y, hasArrow: true, isDashed: false, label: '' },
       ];

       this.nextId = 50;
     },

     // 显示历史泳道图弹框
     showHistoryDialog() {
       this.showHistoryModal = true;
       this.currentPage = 1; // 重置到第一页
     },

     // 关闭历史泳道图弹框
     closeHistoryDialog() {
       this.showHistoryModal = false;
     },

     // 分页切换
     handlePageChange(page) {
       this.currentPage = page;
     },

     // 从历史中加载泳道图
     loadDiagramFromHistory(diagram) {
       this.$confirm('加载泳道图将覆盖当前内容，是否继续？', '提示', {
         confirmButtonText: '确定',
         cancelButtonText: '取消',
         type: 'warning'
       }).then(() => {
         // 清除当前选中状态
         this.clearSelection();

         // 加载泳道图数据
         this.actors = JSON.parse(JSON.stringify(diagram.actors_data || diagram.actors || []));
         this.boundaries = JSON.parse(JSON.stringify(diagram.boundaries || []));
         this.relationships = JSON.parse(JSON.stringify(diagram.relationships || []));
         this.$nextTick(() => this.inferRelationshipIds());

         // 回填左侧表单
         this.aiForm.projectName = diagram.projectName || '';
         this.aiForm.moduleName = diagram.moduleName || '';
         this.aiForm.actorList = diagram.actors ? diagram.actors.split(',').map(s => s.trim()).filter(Boolean) : [];
         this.aiForm.functionDescription = diagram.functionDescription || '';

         // 加载设置
         if (diagram.settings) {
           this.fontFamily = diagram.settings.fontFamily || 'SimSun';
           this.fontSize = diagram.settings.fontSize || 14;
           this.fontWeight = diagram.settings.fontWeight || 'normal';
           this.fontColor = diagram.settings.fontColor || '#333333';
           this.lineColor = diagram.settings.lineColor || '#333333';
           this.lineWidth = diagram.settings.lineWidth || 1;
           this.arrowSize = diagram.settings.arrowSize || 'medium';
         }

         this.currentDiagramId = diagram.id;
         this.showHistoryModal = false;
         this.$message.success('泳道图加载成功');
       }).catch(() => {
         // 用户取消
       });
     },

     // 从历史中删除泳道图
     deleteDiagramFromHistory(index) {
       const diagram = this.savedDiagrams[index];
       this.$confirm('确定要删除泳道图 "' + diagram.projectName + '" 吗？', '提示', {
         confirmButtonText: '确定',
         cancelButtonText: '取消',
         type: 'warning'
       }).then(() => {
         this.savedDiagrams.splice(index, 1);

         // 更新localStorage
         try {
           localStorage.setItem('swimlane_diagrams', JSON.stringify(this.savedDiagrams));
           this.$message.success('泳道图已删除');

           // 如果删除的是当前泳道图，清除currentDiagramId
           if (this.currentDiagramId === diagram.id) {
             this.currentDiagramId = null;
           }
         } catch (error) {
           console.error('删除失败:', error);
           this.$message.error('删除失败');
         }
       }).catch(() => {
         // 用户取消
       });
     },





     // 获取原始数组中的索引（因为表格显示的是倒序）
     getOriginalIndex(diagram) {
       return this.savedDiagrams.findIndex(d => d.id === diagram.id);
     },

     // 获取表格行的类名
     getRowClassName({row, rowIndex}) {
       if (this.currentDiagramId === row.id) {
         return 'current-swimlane-row';
       }
       return '';
     },

     // 格式化绝对时间
     formatAbsoluteTime(timestamp) {
       const date = new Date(timestamp);
       return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
      }
   },

   computed: {
         // 动态字体样式
    dynamicFontStyle() {
      return {
        fontFamily: this.fontFamily,
        fontSize: this.fontSize + 'px',
        fill: this.fontColor,
        fontWeight: this.fontWeight
      };
    },

         // 动态线条样式
    dynamicLineStyle() {
      return {
        stroke: this.lineColor,
        strokeWidth: this.lineWidth
      };
    },

    // 箭头尺寸设置
    arrowDimensions() {
      const sizes = {
        small: { width: 8, height: 6, refX: 7, refY: 3, points: '0 0, 8 3, 0 6' },
        medium: { width: 10, height: 7, refX: 9, refY: 3.5, points: '0 0, 10 3.5, 0 7' },
        large: { width: 12, height: 8, refX: 11, refY: 4, points: '0 0, 12 4, 0 8' }
      };
      return sizes[this.arrowSize] || sizes.medium;
    },

    // 空心箭头尺寸设置
    hollowArrowDimensions() {
      const sizes = {
        small: { width: 10, height: 7, refX: 9, refY: 3.5, points: '0 0, 10 3.5, 0 7' },
        medium: { width: 12, height: 8, refX: 11, refY: 4, points: '0 0, 12 4, 0 8' },
        large: { width: 14, height: 9, refX: 13, refY: 4.5, points: '0 0, 14 4.5, 0 9' }
      };
            return sizes[this.arrowSize] || sizes.medium;
    },

    // 判断是否可以保存
    canSave() {
      return this.actors.length > 0 || this.boundaries.length > 0 || this.relationships.length > 0;
    },

    // 计算viewBox（支持平移和缩放）
    computedViewBox() {
      const w = this.canvasVirtualWidth / this.zoomLevel;
      const h = this.canvasVirtualHeight / this.zoomLevel;
      return `${-this.panX} ${-this.panY} ${w} ${h}`;
    },

         // 按时间倒序排列的泳道图列表（分页）
    reversedSavedDiagrams() {
      const reversed = [...this.savedDiagrams].reverse();
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return reversed.slice(start, end);
    }
  },

  mounted() {
    this.increasePageView();
    this.loadPointsConfig();
    // 监听全屏状态变化
    document.addEventListener('fullscreenchange', this.handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', this.handleFullscreenChange);
    document.addEventListener('msfullscreenchange', this.handleFullscreenChange);

    // 加载已保存的图表列表
    this.savedDiagrams = this.loadSavedDiagrams();

    // 默认加载最新的一条历史泳道图
    if (this.savedDiagrams.length > 0) {
      const latest = this.savedDiagrams[this.savedDiagrams.length - 1];

      // 加载表单数据
      this.aiForm.projectName = latest.projectName || '';
      this.aiForm.moduleName = latest.moduleName || '';
      this.aiForm.actorList = latest.actors ? latest.actors.split(',') : [];
      this.aiForm.functionDescription = latest.functionDescription || '';

      // 加载画布数据
      this.actors = JSON.parse(JSON.stringify(latest.actors_data || latest.actors || []));
      this.useCases = JSON.parse(JSON.stringify(latest.useCases || []));
      this.boundaries = JSON.parse(JSON.stringify(latest.boundaries || []));
      this.relationships = JSON.parse(JSON.stringify(latest.relationships || []));

      // 加载设置
      if (latest.settings) {
        Object.assign(this, latest.settings);
      }

      this.currentDiagramId = latest.id;
      this.$nextTick(() => this.inferRelationshipIds());
      // 回填左侧表单
      this.aiForm.projectName = latest.projectName || '';
      this.aiForm.moduleName = latest.moduleName || '';
      this.aiForm.actorList = latest.actors ? latest.actors.split(',').map(s => s.trim()).filter(Boolean) : [];
      this.aiForm.functionDescription = latest.functionDescription || '';
      if (latest.settings) {
        this.fontFamily = latest.settings.fontFamily || this.fontFamily;
        this.fontSize = latest.settings.fontSize || this.fontSize;
        this.fontWeight = latest.settings.fontWeight || this.fontWeight;
        this.fontColor = latest.settings.fontColor || this.fontColor;
        this.lineColor = latest.settings.lineColor || this.lineColor;
        this.lineWidth = latest.settings.lineWidth || this.lineWidth;
        this.arrowSize = latest.settings.arrowSize || this.arrowSize;
      }
    } else {
      // 无历史数据时加载默认示例（用户下单流程）
      this.loadDefaultDiagram();
    }

    // 页面访问统计
    this.increasePageView();
  },

  beforeDestroy() {
    // 移除全屏监听
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('msfullscreenchange', this.handleFullscreenChange);
  }
}
</script>

<style scoped>
.swimlane-editor {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 118px);
  overflow: hidden;
  padding: 0;
}

/* 全屏状态下的样式优化 */
.swimlane-editor:fullscreen {
  padding: 12px;
}

.swimlane-editor:fullscreen .editor-content {
  height: calc(100vh - 24px);
}

.swimlane-editor:fullscreen .library-card {
  height: calc(100vh - 24px);
}

.swimlane-editor:fullscreen .canvas-card {
  height: calc(100vh - 24px);
}

.swimlane-editor:fullscreen .canvas-content {
  height: calc(100vh - 200px);
}

/* 兼容不同浏览器的全屏伪类 */
.swimlane-editor:-webkit-full-screen {
  padding: 12px;
}

.swimlane-editor:-webkit-full-screen .editor-content {
  height: calc(100vh - 24px);
}

.swimlane-editor:-webkit-full-screen .library-card {
  height: calc(100vh - 24px);
}

.swimlane-editor:-webkit-full-screen .canvas-card {
  height: calc(100vh - 24px);
}

.swimlane-editor:-webkit-full-screen .canvas-content {
  height: calc(100vh - 200px);
}

.swimlane-editor:-moz-full-screen {
  padding: 12px;
}

.swimlane-editor:-moz-full-screen .editor-content {
  height: calc(100vh - 24px);
}

.swimlane-editor:-moz-full-screen .library-card {
  height: calc(100vh - 24px);
}

.swimlane-editor:-moz-full-screen .canvas-card {
  height: calc(100vh - 24px);
}

.swimlane-editor:-moz-full-screen .canvas-content {
  height: calc(100vh - 200px);
}


.editor-content {
  display: flex;
  height: calc(100vh - 118px);
  overflow: hidden;
}

.element-library {
  width: 380px;
  background: #fff;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  z-index: 1;
  border-right: 1px solid #d1d5db;
}

.panel-header {
  padding: 16px 24px;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.panel-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}

.panel-icon {
  width: 22px;
  height: 22px;
  color: #4f46e5;
}

.btn-history {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-size: 13px;
  color: #4f46e5;
  background: #fff;
  border: 1px solid #4f46e5;
  border-radius: 0;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-history:hover {
  background: #4f46e5;
  color: #fff;
}

.btn-history svg {
  width: 16px;
  height: 16px;
}

.header-actions {
  display: flex;
  gap: 8px;
}

.btn-save-primary {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-size: 13px;
  color: #fff;
  background: #4f46e5;
  border: 1px solid #4f46e5;
  border-radius: 0;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-save-primary:hover {
  background: #4338ca;
  border-color: #4338ca;
}

.btn-save-primary:disabled {
  background: #9ca3af;
  border-color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}

.btn-save-primary svg {
  width: 16px;
  height: 16px;
}

.action-buttons {
  padding: 12px 16px;
  flex-shrink: 0;
}

.btn-save {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
}

.library-card {
  height: 100%;
  border: none;
  border-radius: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.library-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.library-header span {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}

.header-actions {
  display: flex;
  gap: 8px;
}

.header-actions .el-button--mini {
  padding: 6px 12px;
  font-size: 13px;
  border-radius: 0;
  transition: all 0.2s;
}

.header-actions .el-button--primary {
  background: #4f46e5;
  border-color: #4f46e5;
  color: #fff;
}

.header-actions .el-button--primary:hover {
  background: #4338ca;
  border-color: #4338ca;
}

.header-actions .el-button--info {
  background: #fff;
  border-color: #4f46e5;
  color: #4f46e5;
}

.header-actions .el-button--info:hover {
  background: #4f46e5;
  color: #fff;
}

/* 提醒区域样式 */
.save-reminder {
  font-size: 14px;
  color: #856404;
  background: #fff3cd;
  padding: 6px 14px;
  border-radius: 4px;
  margin: 12px 16px 0;
  flex-shrink: 0;
}


.library-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.library-content::-webkit-scrollbar {
  display: none;
}

.ai-form-panel {
  padding: 16px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.ai-form-panel .el-form {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.ai-form-panel .el-form-item:last-child {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.ai-form-panel .el-form-item:last-child .el-form-item__content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.ai-form-panel .el-form-item:last-child .el-textarea,
.ai-form-panel .el-form-item:last-child .el-textarea__inner {
  height: 100% !important;
  resize: none;
}

.func-editor {
  flex: 1;
  width: 100%;
  background: #ffffff;
  color: #333;
  font-family: inherit;
  font-size: 13px;
  padding: 16px;
  resize: none;
  border: 1px solid #dcdfe6;
  outline: none;
  line-height: 1.6;
  border-radius: 4px;
  box-sizing: border-box;
  min-height: 0;
  height: calc(100vh - 730px);
}

.ai-form-panel .el-form-item__label {
  font-size: 15px;
  font-weight: 500;
  color: #333;
}

.ai-form-panel .el-input__inner,
.ai-form-panel .el-textarea__inner {
  font-size: 14px;
}

.ai-form-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
}

.ai-icon-small {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

.btn-generate {
  width: 100%;
}

.panel-footer {
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-shrink: 0;
}

.btn-primary, .btn-secondary, .btn-ai {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  border: none;
  transition: background 0.2s;
}

.btn-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-points {
  font-size: 16px;
  font-weight: 600;
  opacity: 0.9;
  white-space: nowrap;
}

.btn-primary {
  background: #4f46e5;
  color: #fff;
}

.btn-primary:hover {
  background: #4338ca;
}

.btn-secondary {
  background: #fff;
  color: #374151;
  border: 1px solid #d1d5db;
}

.btn-secondary:hover {
  background: #f9fafb;
}

.btn-ai {
  background: #10b981;
  color: #fff;
}

.btn-ai:hover {
  background: #059669;
}

.btn-primary svg, .btn-secondary svg, .btn-ai svg {
  width: 22px;
  height: 22px;
}

.btn-ai .ai-icon {
  width: 26px;
  height: 26px;
  object-fit: contain;
}

.element-group {
  margin-bottom: 25px;
}

.element-group h4 {
  margin: 0 0 10px 0;
  color: #666;
  font-size: 14px;
}

.canvas-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f9fafb;
  margin-left: 10px;
  border-left: 1px solid #d1d5db;

}

.tabs-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.tabs {
  display: flex;
  gap: 24px;
}

.tab {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 0;
  font-size: 16px;
  font-weight: 400;
  color: #6b7280;
  background: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}

.tab svg {
  width: 22px;
  height: 22px;
}

.tab:hover {
  color: #374151;
}

.tab.active {
  color: #4f46e5;
}

.tab.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background: #4f46e5;
}

.canvas-card {
  height: 100%;
  border: none;
  border-radius: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.canvas-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.canvas-header span {
  color: #111827;
  font-size: 16px;
  font-weight: 700;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  padding: 10px 24px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
  flex-wrap: wrap;
}

.tip-banner {
  font-size: 14px;
  color: #856404;
  background: #fff3cd;
  padding: 6px 14px;
  border-radius: 4px;
  flex-shrink: 0;
}

.canvas-actions {
  display: flex;
  gap: 10px;
}

.tool-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-size: 13px;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
}

.tool-btn i {
  font-size: 14px;
}

.btn-green {
  background: #10b981;
}

.btn-green:hover {
  background: #059669;
}

.btn-green:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

.btn-teal {
  background: #0891b2;
}

.btn-teal:hover {
  background: #0e7490;
}

.btn-purple {
  background: #8c6ff7;
}

.btn-purple:hover {
  background: #7559d4;
}

.btn-orange {
  background: #f59e0b;
}

.btn-orange:hover {
  background: #d97706;
}

.btn-blue {
  background: #3b82f6;
}

.btn-blue:hover {
  background: #2563eb;
}

.canvas-actions .el-button--mini {
  padding: 6px 12px;
  font-size: 13px;
  border-radius: 4px;
  transition: all 0.2s;
}

.canvas-actions .el-button--warning {
  background: #f59e0b;
  border-color: #f59e0b;
  color: #fff;
}

.canvas-actions .el-button--warning:hover {
  background: #d97706;
  border-color: #d97706;
}

.canvas-actions .el-button--primary {
  background: #3b82f6;
  border-color: #3b82f6;
  color: #fff;
}

.canvas-actions .el-button--primary:hover {
  background: #2563eb;
  border-color: #2563eb;
}

.canvas-actions .el-button--info {
  background: #8c6ff7;
  border-color: #8c6ff7;
  color: #fff;
}

.canvas-actions .el-button--info:hover {
  background: #7559d4;
  border-color: #7559d4;
}

.params-setting {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 16px 24px;
  background-color: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
  flex-wrap: wrap;
}

.param-toolbar {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.param-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.param-item label {
  font-size: 14px;
  color: #374151;
  white-space: nowrap;
  font-weight: 500;
}

.number-input {
  display: flex;
  align-items: center;
  gap: 4px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: white;
  padding: 0 4px;
  height: 32px; /* 与 el-select size="small" 保持一致 */
}

.number-input .el-button {
  width: 20px;
  height: 20px;
  padding: 0;
  min-height: auto;
  border: none;
  background: transparent;
  color: #606266;
  font-size: 14px; /* 与其他输入框字体大小一致 */
}

.number-input .el-button:hover {
  background: #f5f7fa;
  color: #409eff;
}

.number-value {
  min-width: 30px;
  text-align: center;
  font-size: 13px; /* 与其他输入框字体大小一致 */
  color: #606266;
  line-height: 32px;
}

.canvas-content {
  flex: 1;
  overflow: hidden;
  padding: 0;
}

.canvas {
  width: 100%;
  height: 100%;
  position: relative;
  background: white;
  overflow: hidden;
}

.diagram-svg {
  width: 100%;
  height: 100%;
  cursor: grab;
}

.diagram-svg.panning {
  cursor: grabbing !important;
}

.actor {
  cursor: move;
}

.actor.selected {
  filter: drop-shadow(0 0 8px rgba(24, 144, 255, 0.6));
}



.actor-label {
  font-size: 12px;
  font-weight: normal !important;
  fill: #333;
  user-select: none;
  cursor: pointer;
}

.actor-label:hover {
  fill: #1890ff;
}



.boundary-label {
  font-size: 12px;
  fill: #333;
  font-weight: normal;
  user-select: none;
  cursor: pointer;
}

.boundary-label:hover {
  fill: #1890ff;
}

.boundary-label.text-dragging {
  fill: #1890ff;
  cursor: move;
}

.text-drag-area {
  cursor: move;
}

.text-drag-hint {
  pointer-events: none;
}

.relationship-label {
  font-size: 10px;
  fill: #666;
  user-select: none;
}

.delete-btn {
  cursor: pointer;
}

.delete-text-btn {
  cursor: pointer;
}

.add-text-btn {
  cursor: pointer;
}

.delete-btn:hover {
  fill: #ff7875 !important;
}

.resize-handle {
  cursor: pointer;
}

.resize-handle:hover {
  fill: #40a9ff !important;
}

.resize-width {
  cursor: ew-resize;
}

.resize-height {
  cursor: ns-resize;
}

.resize-both {
  cursor: nw-resize;
}

.drag-area {
  cursor: move;
}

.drag-area:hover {
  cursor: grab;
}

.drag-area:active {
  cursor: grabbing;
}

.line-drag-area {
  cursor: move;
}

.line-drag-area:hover {
  cursor: grab;
}

.line-main {
  pointer-events: none;
}

.line-drag-area {
  cursor: move;
}

.line-drag-area:hover {
  cursor: grab;
}

.line-drag-area:active {
  cursor: grabbing;
}

.endpoint-handle {
  cursor: crosshair;
}

.endpoint-handle:hover {
  transform: scale(1.3);
}

.start-point:hover {
  fill: #73d13d;
}

.end-point:hover {
  fill: #40a9ff;
}

/* 内联编辑输入框样式 */
.inline-edit-input {
  width: 100%;
  height: 24px;
  border: 2px solid #1890ff;
  border-radius: 4px;
  padding: 0 8px;
  font-size: 12px;
  text-align: center;
  background: white;
  outline: none;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  font-family: inherit;
  line-height: 24px;
  z-index: 1000;
  box-sizing: border-box;
}

.inline-edit-input:focus {
  border-color: #40a9ff;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
}





/* 历史泳道图弹框样式 */
.history-content {
  min-height: 400px;
}



/* 表格相关样式 */


.diagram-name.current {
  color: #52c41a;
}

.diagram-name.current::after {
  content: " (当前)";
  font-size: 11px;
  color: #52c41a;
  font-weight: normal;
}

.diagram-content {
  font-size: 13px;
  color: #666;
  line-height: 1.4;
}

.time-info {
  text-align: left;
}

.absolute-time {
  font-size: 13px;
  color: #666;
  font-weight: 500;
}

.action-buttons {
  display: flex;
  gap: 4px;
}

/* 当前泳道图行高亮 */
.el-table /deep/ .current-swimlane-row {
  background-color: #f6ffed !important;
}

.el-table /deep/ .current-swimlane-row:hover td {
  background-color: #f6ffed !important;
}

/* 分页样式 */
.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  padding: 16px 0;
}

/* 底部说明样式 */
.history-footer {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e9ecef;
}

.history-description {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 6px;
}

.history-description p {
  margin: 0 0 8px 0;
  font-size: 14px;
  color: #333;
}

.history-description ul {
  margin: 8px 0 0 0;
  padding-left: 0;
  list-style: none;
}

.history-description li {
  margin: 4px 0;
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}

.actor-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-height: 32px;
  padding: 4px 0;
}

.actor-tip {
  margin-top: 6px;
  font-size: 14px;
  color: #856404;
  background: #fff3cd;
  padding: 6px 14px;
  border-radius: 4px;
}
</style>






